let book1=[];
book1[0] = [
            {
                "name": "New words",
                "children": [
                    {
                        "word": "ambition",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f4083027b5bd654ef6507cb6ec3119a34593e21b_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/æmˈbɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [U] determination to be successful, rich, powerful, etc. 抱负；雄心；野心",
                                        "example": "She was intelligent but suffered from a lack of ambition."
                                    },
                                    {
                                        "explanation": "2) [C] a strong desire to achieve sth. 追求；夙愿；理想",
                                        "example": "Earlier this year, he achieved his ambition of competing in the Olympic Games."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "ambitious",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6da714f470195887c7aa2e075eb622730c5924be_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/æmˈbɪʃəs/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "determined to be successful, rich, powerful, etc. 有抱负的；有雄心的；野心勃勃的",
                                        "example": "She's extremely ambitious and intends to be running her own company by the time she's 30."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "someday",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/354c4e78a1d4ecbe7e6b9263754d5bd2f174e523_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsʌmˌdeɪ/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(also 'some day') at an unknown time in the future, esp. a long time in the future 将来会有一天；有朝一日",
                                        "example": " He hopes, someday, to have his own business."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "matter-of-factly",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3a44a36b8628cdabb618e0f2658dd5c69bd42813_96k.mp3#duration=2.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌmæt(ə)r ə(v) ˈfæktli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "in a way that shows no emotion when you are talking about sth. exciting, frightening, etc. 就事论事地；不带感情地；实事求是地",
                                        "example": "To my surprise, he spoke about his divorce matter-of-factly."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "biology",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9b9914d346dce6383cc7a215692995085d42ef7b_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/baɪˈɒlədʒi/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the scientific study of living things 生物学",
                                        "example": "Students might pursue a degree in biology as a path to medical school or a variety of professions."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "resolve",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c9d4d23ee39ebad382b9ea5104b2cd61e3d81440_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈzɒlv/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "find a satisfactory way of dealing with a problem or difficulty 解决（问题、困难）",
                                        "example": "There weren't enough beds, but the matter was resolved by George sleeping on the sofa."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fiction",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5c40a258ece636433e315527acbe74d22ec34224_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfɪkʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] books and stories about imaginary people and events 小说",
                                        "example": "The book is a work of fiction and not intended as a historical account."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "freshman",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a03c9ff4644c77b22a4b79fb4b57b3a67bc4e4b3_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfreʃmən/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (AmE) a student in the first year of high school or university （高中或大学的）一年级学生",
                                        "example": "It is necessary for freshmen to get to know their new studying environment in university as soon as possible."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "pretend",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b0a42e961d9f32b5610dcb66f7eb4a6af8044da8_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/prɪˈtend/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "behave as if sth. is true when in fact you know it is not, in order to deceive people or for fun 假装；装作",
                                        "example": "She pretended that she was not at home when we rang the bell."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "desperate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d059d4a16200728a5acb7194c6175880f24cb6c7_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdesp(ə)rət/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (~ for sth.; ~ to do sth.) needing or wanting sth. very much 非常需要···的；极其需要···的",
                                        "example": "The healthcare industry is desperate for solutions to its business models."
                                    },
                                    {
                                        "explanation": "2) willing to do anything to change a very bad situation, and not caring about danger （为了改变糟糕境遇而）不惜冒险的，拼命的，绝望的",
                                        "example": "I had no money left and was desperate."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "buddy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ba94fe7e66ee9ed7c1a8726ae71b69f9b2238380_96k.mp3#duration=0.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈbʌdi/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (infml.) a friend 朋友；伙伴",
                                        "example": "Bob and I have been great buddies for years."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "entertaining",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1a7b10d1d22b046d385c0d0a50b7f2aa1578f5cc_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌentəˈteɪnɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "amusing and interesting 使人愉快的；有趣的",
                                        "example": "His books aren't particularly well-written, but they're always entertaining."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "apologetic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ee71a3c5f8fdf99b57fb0fe76ca1d6fcf0a9d4c5_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˌpɒləˈdʒetɪk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "showing or saying that you are sorry that sth. has happened, esp. because you feel guilty or embarrassed about it 道歉的；谢罪的；愧疚的",
                                        "example": "  She was apologetic about my injury."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "attain",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/80c58e81c898b30a147b708c05a55bb61dbcccf6_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈteɪn/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "succeed in achieving sth. after trying for a long time （通过长时间努力而）得到，获得，赢得",
                                        "example": "  More and more women are attaining positions of power."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "attainable",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e460599559aee846afdcf341fb3b12f49576c585_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈteɪnəbl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "possible to achieve, reach, or get 可以达到的；可以获得的",
                                        "example": "  We must make sure that we do not set ourselves goals that are not attainable."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "determination",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ff115a6cff327f2293aa29d7992b9ef0d0bbf3dc_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˌtɜːmɪˈneɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the quality of trying to do sth. even when it is difficult 决心；坚韧；毅力",
                                        "example": "  He shows great determination to learn English."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "realistic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/41bc6a718df1b4a4b007aad69c0cc1a2a0393a66_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌrɪəˈlɪstɪk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "accepting things as they are in fact and not making decisions based on unlikely hopes for the future 现实的；实际的；实事求是的",
                                        "example": "  Let's be realistic about this 一 I just can't afford to pay that much money."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "jungle",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/398b5ef820eb5b79fdb8f25a37134645616fec67_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdʒʌŋgl/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a thick tropical forest with many large plants growing very close together （热带）丛林",
                                        "example": "  We had to cut our way through dense jungle."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fated",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ca46ba8e91b76a7420a320f0c9876e74d322b60f_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfeɪtɪd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "certain to happen or to do sth. because a mysterious force is controlling events 命运决定的；命中注定的",
                                        "example": "  She says she was fated to become a writer."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "adventurous",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e963a8bb6a643e5b57c59e888ac7e73600469bbc_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ədˈventʃ(ə)rəs/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) eager to go to new places and do exciting or dangerous things 喜欢冒险的；有冒险精神的",
                                        "example": "  I took an adventurous ski trip in Austria last year."
                                    },
                                    {
                                        "explanation": "2) not afraid of taking risks or trying new things 大胆创新的",
                                        "example": "  Warren is a very adventurous cook, always trying to make new dishes."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "exotic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7de82f2121f3885d6d604a2cd9abfad33654d3f5_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪgˈzɒtɪk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "sth. that is exotic seems unusual and interesting because it is related to a foreign country 异国风情的；外国情调的",
                                        "example": "  She likes traveling to all kinds of exotic locations."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "string",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/377cc8d91b041a6a6134b2e7097c285db950e05c_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/strɪŋ/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[n.] 1) [C] (~ of) a group of similar things 一系列",
                                        "example": "  We've had a string of complaints about the program."
                                    },
                                    {
                                        "explanation": "[n.] 2) [C, U]（由几股合成的）线，细绳，带子",
                                        "example": "  Her key hung on a string around her neck."
                                    },
                                    {
                                        "explanation": "[vt.]3)\n(strung, strung) put things together onto a thread, chain, etc. 用（线、 链等）穿起来",
                                        "example": "  She had strung the shells on a silver chain."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "conflict",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e48961e68656a849692cc57a872714072f2e511f_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkɒnflɪkt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a state of disagreement or argument between people, groups, countries, etc. （意见等的）抵触，冲突，矛盾",
                                        "example": "  She found herself in conflict with her parents over her future career."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "whole-heartedly",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9f05e16dbf5bdb137def083dc363c4a83832ef81_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌhəʊl ˈhɑːtɪdli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "in a way that involves all your feelings, interest, etc. 全心全意地；全力以赴地",
                                        "example": "  I agree whole-heartedly with the mayor on this issue."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "single-mindedly",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b0503e10e6eba37861ec58681adfaebe0f5d8a83_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌsɪŋgl ˈmaɪndɪdli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if one person does sth. single-mindedly, they have one clear aim and work very hard to achieve it 一心一意地；专心致志地",
                                        "example": "  His ability to concentrate single-mindedly on the most important thing leads to his success."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "greedy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4afe2bab1a39cf0e0ba48d629968624ca2725ad0_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈgriːdi/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "always wanting more food, money, power, possessions, etc. than you need 贪婪的；贪心的； 贪吃的；贪喝的",
                                        "example": "  He looked at the gold with greedy eyes."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "chaotic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/01e467cd78ea7de0f0b14900f201410834db7eac_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/keɪˈɒtɪk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "a chaotic situation is one in which everything is happening in a confused way 混乱的； 毫无秩序的",
                                        "example": "  The traffic in the city is chaotic in the rush hour."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "overdue",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/20704945bcde3b7e6d34f39af26d2336eb70bf16_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌəʊvəˈdjuː/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) if sb. /sth. is overdue, they should have arrived before now 迟到的；延误的",
                                        "example": "  If you're overdue for a vacation, you can prepare for an adventure instead of cancelling it."
                                    },
                                    {
                                        "explanation": "2) not done, paid, returned, etc. by the time expected 过期未完成的；过期未付的；过期未还的",
                                        "example": "  These books are overdue and you should pay a fine."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "mature",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c4bb5dd64430964cfb2f91f889716db72217a0a3_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/məˈtʃʊə/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "sb., esp. a child or young person, who is mature behaves in a sensible and reasonable way, as you would expect an adult to behave （尤指小孩或年轻人举止）成熟的，理智的，明白事理的",
                                        "example": "  We're mature enough to disagree on this issue but still respect each other."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "assign",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ef4fada0ba3c8a63063137a3134403a472ef13e4_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈsaɪn/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "give sb. a particular job or make them responsible for a particular person or thing 分配，分派，指派（任务）",
                                        "example": "  I've been assigned the task of looking after the new students."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "pediatrician",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6edee8b01faa12d8a2456f2d47e43dfd74fc26b3_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌpiːdiəˈtrɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (BrE 【paediatrician】)a doctor who deals with children and their illnesses 儿科医生",
                                        "example": "  He dreams of becoming a doctor, specifically a pediatrician."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "best-seller",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b69ad0d2278573910a1cc2d839f03ed94cd34a5d_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌbest ˈselə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a popular product, esp. a book, that many people buy 畅销产品；畅销书",
                                        "example": "  His new book went straight to No. 1 on the best-seller list."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "anymore",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6610c1e4ed41e36355efa8fa724fdb634b3b93aa_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌeniˈmɔː/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(often used in negative sentences or questions) any longer 再也（不）；（不）再",
                                        "example": "  You're describing a world that just doesn't exist anymore."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "strive",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/158bf07f2f8fdb81c926a8f3a6842946bdcbe36f_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/straɪv/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(strove, striven) (~ to do sth.; ~ for / after sth.)  make a great effort to achieve sth. 努力；奋斗",
                                        "example": "We encourage all members to strive for the highest standards."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "best-selling",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cc41e35f1eb201aa16c9c7a6f68b501ea2d9847e_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌbest ˈselɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) extremely popular 畅销的",
                                        "example": "It's almost every author's dream to become a best-selling author."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "press conference",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f686a87d2a6b24fda836412d4ec16f2b68337877_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkɒnf(ə)rəns/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a meeting held by a person or group at which they answer questions from people who write or present news reports 记者招待会；新闻发布会",
                                        "example": "The football coach held a press conference to announce his retirement."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "appealing",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/55f8d878d82f613c7684a98b2f4926b3d772745f_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈpiːlɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "attractive or interesting 有吸引力的；有趣的",
                                        "example": "The city offers an appealing combination of sporting and cultural events."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "tongue",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e00446615ac7d9d54fbe9ab10b2b464186303d5d_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/tʌŋ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 舌；舌头"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "depression",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/17f1832901ba6e90052abb839a19b9faf042abcf_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈpreʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a feeling of sadness that makes you think there is no hope for the future 忧伤；沮丧；消沉",
                                        "example": "She suffered from severe depression after losing her job."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "isolation",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/46467fa7a46dacfd3f02f4adacfa73218a241a9e_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌaɪsəˈleɪʃn/【n.】 [U]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) when sb. feels alone and unable to meet or speak to other people 孤独；孤单",
                                        "example": "After all the visitors had left, she experienced a feeling of complete isolation."
                                    },
                                    {
                                        "explanation": "2) when one group, person, or thing is separate from others 隔绝；孤立；分离",
                                        "example": "Because of its geographical isolation, the area developed its own unique culture."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "employee",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9714c953ef1890ca9047fcbe7d731ae0e39fa1fc_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪmˈplɔɪiː/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb. who is paid to work for sb. else 受雇者；雇员",
                                        "example": "e.g.  Alibaba Group has more than 100,000 global employees."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "philosopher",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/31683ed98a3ae0c62df00640ec2dfce1b241d8ce_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/fɪˈlɒsəfə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb. who studies and develops ideas about the nature and meaning of existence, truth, good and evil, etc. 哲学家",
                                        "example": "Socrates and Plato are two famous Greek philosophers whose ideas are still influential today."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unfold",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3d788476ebc4238deede0a389ff3f6c676d96ebc_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ʌnˈfəʊld/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if a story, plan, etc. unfolds, it becomes clearer as you hear or learn more about it （使）（故事、计划等）展开；逐渐呈现；展示",
                                        "example": "The scandal is still unfolding, but there may be a solution soon."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "mindset",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/86dcc40fd3207477f9b846c449d4417efb087158_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmaɪndˌset/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb.'s general attitude, and the way in which they think about things and make decisions 思维模式",
                                        "example": "It's quite difficult to change the mindset of the public and the press."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "lessen",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/454dc51401321682954660265b12a07660dd84da_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlesn/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "become smaller in size, importance, or value, or make sth. do this （使）降低；（使）减少",
                                        "example": "The new project will lessen the effects of car pollution."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "emotional",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/73c6fc3d628e1ad40e40904cb5473e9c7f3a423a_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈməʊʃn(ə)l/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) relating to your feelings or how you control them 情绪（上）的；情感（上）的",
                                        "example": "Mothers are often the ones who provide emotional support for the family."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "perceive",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/646239c3d75cea6b01e5fcc87420a520084c3411_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/pəˈsiːv/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (fml.) notice, see, or recognize sth. 察觉；注意到；发觉",
                                        "example": "That morning, he perceived a change in his wife's mood."
                                    },
                                    {
                                        "explanation": "2) (written) understand or think of sb. / sth. in a particular way （以某种方式）看待，理解",
                                        "example": "Even as a young woman she had been perceived as a future chief executive."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "heroic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cc3f9bd8b2ca053e54abcfa0edccd129cc3d096d_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/hɪˈrəʊɪk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "extremely brave or determined, and admired by many people 英雄的；英勇的",
                                        "example": "These doctors performed heroic work in difficult conditions."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "consistent",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d3d3dbac7ebabf87a01822e1ec7109109e66f6af_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈsɪstənt/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "always behaving in the same way or having the same attitudes, standards, etc. （行为、态度、标准等）一贯的，一致的",
                                        "example": "He has been the team's most consistent player."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sustainable",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9a75fbfb634be712a387e1aeb9d61378c493d92c_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/səˈsteɪnəbl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "able to continue for a long time 可持续的",
                                        "example": "That sort of extreme diet is not sustainable over a long period."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fitness",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/18b511b92ab44bd8b49d47d88c3047fa914a6baa_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfɪtnəs/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] when you are healthy and strong enough to do hard work or play sports 健壮；健康",
                                        "example": "They're doing some regular exercise to improve their fitness."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "creativity",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c759da9cd0cc32ef2e7e4956eb5b3e04230af12c_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌkriːeɪˈtɪvəti/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the ability to use your imagination to produce new ideas, make things, etc. 独创性；创造性；创造力",
                                        "example": "We should have an education system that lets children use their creativity."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "marathon",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9b0c0dc0fe05172025a8bfdac3141700fb1cbed4_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmærəθ(ə)n/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] a long race of about 42 kilometers or 26 miles 马拉松赛跑",
                                        "example": "She ran her first marathon in just under three hours."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "literally",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0ae76455ed3c87c2eb4782d710345603e4d62707_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlɪt(ə)rəli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) used to emphasize that sth., esp. a large number, is actually true 的确；确实",
                                        "example": "The Olympic Games were watched by literally billions of people around the world."
                                    },
                                    {
                                        "explanation": "2) according to the most basic or original meaning of a word or expression 按照原意；根据字面意思",
                                        "example": "I said I felt like quitting, but I didn't mean it literally."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "overextend",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7fada49c36ef8b2ab095ab5a00abab8ddb1a5d9a_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌəʊvərɪkˈstend/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "try to do or use too much of sth., causing problems, illness, or damage 把···做得过分；把···使用过头",
                                        "example": "e.g .  Be careful not to overextend yourself. You've been very ill."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "obsess",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/36b733655b93643e38cdec10dc523d2349f01bdd_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əbˈses/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(be obsessed with / by) if sb. / sth. obsesses you, you think or worry about them all the time and you cannot think about anything else 一 used to show disapproval 使痴迷；使迷恋；使心神不宁（含贬义）",
                                        "example": "A lot of young girls are obsessed by their weight."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "maximum",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/40d38c35888501333ab58ff5ac706eba6ae8e7f5_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmæksɪməm/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) the maximum amount, quantity, speed, etc. is the largest that is possible or is allowed 最大量的；最大限度的；最大值的",
                                        "example": "To get the maximum benefit, do the exercises slowly."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "workout",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/520eb4fdab4530b469934c72e888ff8467d06185_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈwɜːkaʊt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a period of physical exercise, esp. as training for a sport 体育锻炼；训练",
                                        "example": "She does a 20-minute workout every morning."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unlike",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b9b6a7139d29bec29ec337f6978312a1fce80af1_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ʌnˈlaɪk/【prep.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used to contrast sb. / sth. with another person or thing 与···不同",
                                        "example": "Unlike most people in the office, I don't come to work by car."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "paradox",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/45b9711aff4643cafb0c7fada28fe6fa0294de75_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈpærəˌdɒks/【n.】 [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) a situation that seems strange because it involves two ideas or qualities that are very different 自相矛盾（的情况）",
                                        "example": "It is a paradox that in such a rich country there can be so much poverty."
                                    },
                                    {
                                        "explanation": "2) a statement that seems impossible because it contains two opposing ideas that are both true 悖论；似非而是的说法",
                                        "example": "The paradox is that fishermen would catch more fish if they fished less."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "perform",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a20b80e9f8cb07c358071768cbd2d8c8d7d76519_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/pəˈfɔːm/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "vi.\n(~ well / badly, etc.) work or do sth. well, badly, etc. 表现得好 / 差等",
                                        "example": "The company has been performing poorly over the past year."
                                    },
                                    {
                                        "explanation": "v. \ndo sth. to entertain people, for example by acting a play or playing a piece of music 表演；演出",
                                        "example": "I'd like to hear the music performed live."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "chase",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0133fb0a9250bae176652fc741950652d08f5f2e_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/tʃeɪs/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) use a lot of time and effort trying to get sth. such as work or money 努力赢得；设法获得",
                                        "example": "Top graduates from the university are chased by major companies."
                                    },
                                    {
                                        "explanation": "2) quickly follow sb. / sth. in order to catch them 追逐；追赶；追捕",
                                        "example": "The dogs saw him running and chased him."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "grounded",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ac5fbd9f0bebcd487da744a686afefa52ab9da62_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈgraʊndɪd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) sb. who is grounded understands their own character and knows what is really important 对自己有清醒认识的",
                                        "example": "Mary says that she knows what she really wants because her family always keeps her grounded."
                                    },
                                    {
                                        "explanation": "2）reasonable and in control of your emotions, even when this is difficult 理性的；有理智的；克制的",
                                        "example": "Charles can always keep himself grounded, even when he runs into difficulty."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "productive",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c1dc94eb3a653983a497ffe458a3a19a95faa307_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/prəˈdʌktɪv/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "producing or achieving a lot 多产的；丰饶的；富有成效的",
                                        "example": "We had a very productive meeting 一 I felt we sorted out a lot of problems."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "ethos",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/82f8dfe4575d3cece5c378ce3e459c90fb50000b_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈiːθɒs/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[sing.] the set of ideas and moral attitudes that are typical of a particular group （某团体的）精神特质，道德意识",
                                        "example": "It is a community in which people lived according to an ethos of sharing and caring."
                                    }
                                ]
                            }
                        ]
                    }
                ]
                
            },
            {
                "name": "Phrases and expressions",
                "children": [
                    {
                        "word": "be sb's for the asking",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(infml.) if sth. is yours for the asking, you can have it if you want it 某人只要提出要求（就可以得到）",
                                        "example": "A good deal of extra support is hers for the asking."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/10a03f4af315d3cc7ee6b17599d506d90edfc2d8_96k.mp3#duration=3.0&t=.mp3"
                    },
                    {
                        "word": "hit it big",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7201e427cd5470ba35a53b7512bb86b07231617f_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "have great success 大获成功",
                                        "example": "  I wasn't expecting it to work, but I hit it big when I tried the new approach."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "to tell (you) the truth",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/007513c4586a60e98d0affafa613fd751a37e459_96k.mp3#duration=6.0&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(spoken) used when giving your personal opinion or admitting sth. 老实说；实话对你讲",
                                        "example": "  To tell the truth, I don't really like her."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "leave behind",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0f181e3cdc2bfc1975ecee436d88595db98f6d38_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "not take sb. / sth. with you when you leave a place 忘记带走；留下",
                                        "example": "  He departed for the United States, leaving the children behind with his mother."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sit back",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c5d4800c667f6600fea2e2820a2d06cea85f6078_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "relax and make no effort to get involved in sth. or influence what happens 不采取行动；袖手旁观",
                                        "example": "  Don't just sit back and wait for new business to come to you."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "for one reason or another",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/af1047606f624af054802a529c3480f1af4e8d76_96k.mp3#duration=2.7&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used for saying that there is more than one reason for sth. 由于这样或那样的原因",
                                        "example": "  His travel articles are always, for one reason or another, fascinating."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "grab for ∕ at",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/da1ed744affaa588fa0d28e2568eaabb5eaaa0c0_96k.mp3#duration=3.7&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(infml.) take an opportunity, accept an invitation, etc. immediately 抓住（机会）；立即接受（邀请等）",
                                        "example": "  This is our chance to grab at this new market."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "come to terms with",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0bdafe4c9b007a230218787c3a5bb1113830b733_96k.mp3#duration=2.2&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "accept an unpleasant or sad situation and no longer feel upset or angry about it 与某事妥协，对某事让步；接受（令人不快或悲伤的现实）",
                                        "example": "  It's hard for the couple to come to terms with the fact that they will never have children."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "hold back",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5d12a1d82513605deee6b4914bfdd20d51ab7a4c_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "prevent sb. / sth. from making progress 阻碍某人 / 某事发展",
                                        "example": "Do you think that mixed-ability teaching holds the brighter children back?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "roll / trip off the tongue",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/eb1a12015bafd5cbe328c48331688673b8b95f12_96k.mp3#duration=4.3&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(infml.) if a name or phrase rolls or trips off your tongue, it is easy or pleasant to say （某个名字或短语）顺口",
                                        "example": "Their names roll off the tongue very easily."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "be / get / feel burned out",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8a19af4b3c1a89100a569b9a131196408dbac053_96k.mp3#duration=6.1&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "be in a state of physical or mental exhaustion caused by overwork or stress 感到精疲力竭",
                                        "example": "He was burned out by the time he was 21 and retired from the sport."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "the here and now",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6defd82c7659134dff67dbae1977d7525c3a3283_96k.mp3#duration=2.0&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "the present time 现时",
                                        "example": "To be able to live fully in the here and now, one must first learn how to honor the past."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "come up short",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f9c6d82e4575073b008f68050c31a0630e8c4787_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "fail to win or achieve sth. 未能赢取；未能获得",
                                        "example": "We're so close to getting the job done, but we keep coming up short."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "add up",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/69c8f75a8527c70294cc875201caf86dc1acac78_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "increase by small amounts until there is a large total 积累；积少成多",
                                        "example": "When you're feeding a family of six the bills soon add up."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "string together",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8c0318d508f3b0c991c7cd42a29bbcb5ec90c72a_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "combine things in order to make sth. that is complete, good, useful, etc. 把···拼在一起",
                                        "example": "They string together image after image until the documentary is completed."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "prior to",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9be6cd3b0ee39a526a5f594f6aad4c51b9453aea_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(fml.) before 在···以前",
                                        "example": "All the arrangements should be completed prior to your departure."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "at peace",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/14bc39fef07f10d182d4e5bf526d6fafd1c387ee_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if you are at peace, you do not feel angry, unhappy, etc. 心平气和的",
                                        "example": "For the first time in months, she felt calm and at peace with the world."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "quite / just the opposite",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/00d37c689f0c9417cebfd47ecdf8c461df50a3e4_96k.mp3#duration=3.8&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used to say that sth. is completely different from what has just been said 正好 / 完全相反",
                                        "example": "I didn't feel sleepy at all 一 just the opposite, in fact."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "run / be / go counter to",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6c952a53163c2ab10d230a8e469abf956770dfd1_96k.mp3#duration=5.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "be the opposite of 违背某事；与某事背道而驰",
                                        "example": "The governor's newest policy seems to be running counter to everything he promised during his election campaign."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Proper names",
                "children": [
                    {
                        "word": "Beth",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "贝丝（人名）"
                                    }
                                ],
                                "partOfSpeech": "/beθ/"
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2a3a0b61da52c9851637634d418e89b629b7aa74_96k.mp3#duration=0.8&t=.mp3"
                    },
                    {
                        "word": "Secretary of State",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/094c08609812546842e5d37aa0868bd817056de8_96k.mp3#duration=2.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "（美国政府的）国务卿（主要负责外交事务）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Jane Goodall",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b8f7c14f6230b3070181326e5d756c0511f956cb_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌdʒeɪn ˈgʊdɔːl/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "简·古多尔（英国生物学家、动物行为学家、人类学家）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "J.J. Watt",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0d84ede78c8cdcaab027385751e6b0e20b10747a_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/wɒt/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "J.J. 瓦特（美国橄榄球运动员）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Eliud Kipchoge",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d4278635ca4f93e824264c6d5b1305a18f93fd19_96k.mp3#duration=2.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɪljuːd ˈkɪpˌtʃəʊgi/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "埃利乌德 ; 基普乔盖（肯尼亚马拉松运动员）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "The New York Times】",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1cafa3d20e36c3b54b13209d3b1307b42c4c03fd_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "《纽约时报》（报刊名）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "The Times】",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4750c00c8bd3cbee083cbe3eb01ff9b919b43836_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "《泰晤士报》（报刊名）"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]

book1[1] = [
            {
                "name": "New words",
                "children": [
                    {
                        "word": "dispute",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c016db833e039b0154907ec3e705a7233bea5d7c_96k.mp3#duration=3.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdɪspjuːt; dɪˈspjuːt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a serious argument or disagreement 争议；争论；争端；纠纷",
                                        "example": "The firm is involved in a legal dispute with its competitor."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "indisputable",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/995255c9a1d3faeec0abd5a97629b3a992f4b4ad_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɪndɪˈspjuːtəbl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "unable to be challenged or denied 无可争辩的；不可否认的",
                                        "example": "It is indisputable that the crime rate has been decreasing."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "explanation",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c73a7ae0f56ff22e0af6daf3b49cdce6e825b291_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌekspləˈneɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a statement or account that makes sth. clear or easy to understand 解释；说明",
                                        "example": "Could you give me a quick explanation of how the machine works?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "straightforward",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e4c5ad3ad1a614c2c02e3fa5e9dc0dae1290949d_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌstreɪtˈfɔːwəd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "simple and easy to understand 简单的；易懂的",
                                        "example": "The question seemed straightforward enough."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "economics",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/477ae9077fa3dbcff9f4b7024c20196ecfc0d784_96k.mp3#duration=4.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌiːkəˈnɒmɪks; ˌekəˈnɑmɪks/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the study of the way in which money and goods are produced and used 经济学"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "economy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4c1e2fcd388454b2c13694baa99a7e0001fc3cfa_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈkɒnəmi/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] the wealth that a country gets from business and industry 经济",
                                        "example": "The country's economy grew at an annual rate of more than 10 percent."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "squeeze",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c88b1297655043210e08c9813d4da7b9033cc84e_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/skwiːz/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "firmly press sth., typically with your fingers 挤；捏",
                                        "example": "As she waited for the interview, he squeezed her hand and wished her good luck."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "engage",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3bb443064925ec7f62897bd61037cfe317da88f5_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈgeɪdʒ/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ sb. in sth.; ~ in sth.) make sb. take part in sth.; take part in sth. （使）从事，参加",
                                        "example": "The two governments have agreed to engage in a dialogue to solve the problem."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dominate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/89cb2b4ca71b37d0aa567e7f1437130e5adce8b5_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdɒmɪˌneɪt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "control or have a lot of influence over sb. / sth., esp. in an unpleasant way 支配；控制；左右；影响",
                                        "example": "The industry is dominated by five multinational companies."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "manufacture",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cf35fb175f6eecf7428ec42681789d9f5e13e114_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌmænjʊˈfæktʃə/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【vt.】\nuse machines to make goods or materials, usu. in large numbers or amounts （用机器大量）生产，制造",
                                        "example": "It is a company that manufactures drugs."
                                    },
                                    {
                                        "explanation": "【n.】\n[U] the process of making goods or materials using machines, usu. in large numbers or amounts （大量商品的）生产，制造",
                                        "example": "Cost will determine the methods of manufacture."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "manufacturing",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/95537ef451260dbeece9ddc8de75806250cfccdb_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌmænjʊˈfæktʃərɪŋ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the process or business of producing goods in factories 制造；制造业",
                                        "example": "Thousands of jobs had been lost in manufacturing."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "harvest",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d1b1d45485907da8641fb81fd40ce99335225311_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈhɑːvɪst/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[vt.]gather in crops 收割",
                                        "example": "Farmers here still plant and harvest their crops by hand."
                                    },
                                    {
                                        "explanation": "[n.][C, U] the process or period of gathering in crops 收割；收获季节",
                                        "example": "The drought has made farmers anxious about the harvest."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "ripe",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/683bd2abd2274b4c4e843a0694f75a2104293fc8_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/raɪp/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(of fruit or crops) fully grown and ready to eat （水果或庄稼）成熟的",
                                        "example": "Those tomatoes aren't ripe yet —— they're still green."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "infinite",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f7ed527be953934638f7c5b66b2717d7540d2f06_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɪnfɪnət/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) without limits, edges, or ends 无限的",
                                        "example": "Her fellow members marveled at her seemingly infinite energy."
                                    },
                                    {
                                        "explanation": "2) very great in amount or degree （数量或程度上）极大的",
                                        "example": "There was an infinite variety of drinks to choose from."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "incoming",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/861653d6a06ac9270fa508a5505eb74ab94aa31c_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɪnˌkʌmɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(of a message) being received rather than sent （消息）接收到的",
                                        "example": "My email box is flooded with incoming messages when a school year begins."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "mobile",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b2cbd65e102d08b53827b9c71ea6191fc34d956b_96k.mp3#duration=3.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈməʊbaɪl; ˈməʊbiːl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) relating to mobile phones and similar technology 与移动电话等技术有关的",
                                        "example": "Over half of the country's e-commerce is now conducted on mobile devices."
                                    },
                                    {
                                        "explanation": "2) able to be moved from one place to another 可移动的",
                                        "example": "The seats in the classroom are not mobile."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "handle",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1a6ef337376bc84314abaf885ab26e651432feaa_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈhændl/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "deal with 处理；应付",
                                        "example": "If you can't handle the job, I'll ask someone else to do it."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "to-do list",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/57ffa89c16910002887fabc73763ec209cf32938_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/lɪst/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a list of tasks that need to be done 待办清单",
                                        "example": "I'll take a moment away from my to-do list and think about my dream holiday."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "inevitably",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9fb44c5e832b952389a03e7994f8c440a00efd9a_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈevɪtəbli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "as is certain to happen 不可避免地；必然地",
                                        "example": "One's accent inevitably gives away their place of origin."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "overwhelm",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fc3719406c5d22f40c4e64c1ef872240252f3600_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌəʊvəˈwelm/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) give too much of a thing to sb. 压垮；使应接不暇",
                                        "example": "We were overwhelmed by requests for information."
                                    },
                                    {
                                        "explanation": "2) have a very strong emotional effect on sb. （感情上）使（某人）感到不能自持，使不知所措",
                                        "example": "She was overwhelmed by the need to talk to someone."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "finite",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9389f183b682c03a860e4bbbbd7922ef3a739ab0_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfaɪnaɪt/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "having a definite limit or fixed size 有限的；有限制的",
                                        "example": "Every computer has a finite amount of memory."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "demonstrate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b0d040cd80277d206f15d0c30c3c507b8d21e0c7_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdemənˌstreɪt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "show or prove sth. clearly 说明；证明；论证；证实",
                                        "example": "Hitchcock's films demonstrate that a British filmmaker could learn from Hollywood."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "ironic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/29e396bdf86b4549928ff2dc63b0481be8c96177_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/aɪˈrɒnɪk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(of a situation) strange or amusing because it is very different from what you expect （情况）出乎意料的，令人啼笑皆非的",
                                        "example": "It's ironic that she became a teacher —— she used to hate school."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "economist",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5b71dbc6205d1ee25fb3a6608c45c5b905ef11fe_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈkɒnəmɪst/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a person who studies or writes about economics 经济学家"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "scarcity",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a6e56d9c477f706c3c86a3824a644e6ca107ed7f_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈskeəsəti/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[sing.] a situation in which there is not enough of sth. 不足；短缺",
                                        "example": "Many college graduates hunt for jobs in large cities owing to the scarcity of opportunities in small towns."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "commitment",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c173316b6e7ee533d45e51e0f6797703fcaeda64_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kəˈmɪtmənt/【n.】 [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) sth. that you have promised or agreed to do, or that you have to do 已承诺（或同意）的事；不得不做的事",
                                        "example": "Women often have to strike a balance between work and their family commitments."
                                    },
                                    {
                                        "explanation": "2) a promise to do sth. or to behave in a particular way 承诺",
                                        "example": "Alice doesn't want to make a big emotional commitment to Steve at the moment."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "priority",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9aae4c10d9601b0186de6e000a6c3f0f90c88217_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/praɪˈɒrəti/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] the thing that you think is most important and that needs attention before anything else 优先处理的事；当务之急",
                                        "example": "The customer is high on our list of priority."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "prioritise",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/06fe60c76928c7458a67945fcaaae4a72dfea90b_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/praɪˈɒrɪˌtaɪz/【vt. (AmE prioritize)",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) treat sth. as being more important than other things 优先考虑；优先处理",
                                        "example": "The company has failed to prioritise safety."
                                    },
                                    {
                                        "explanation": "2) determine the order for dealing with a series of items or tasks according to their relative importance 确定优先次序",
                                        "example": "You should make a list of all the jobs you have to do and prioritise them."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "crucial",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ea073c334f0d0bb04dff286f04e33775288c85b6_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkruːʃl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "extremely important because it will affect other things 至关重要的；关键性的",
                                        "example": "This aid money is crucial to the government's economic policies."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "infect",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/bb9edb881ac4f1064c2d8b6a9e9ff391c5a01fd5_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈfekt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) make sb. share a particular feeling 使感染（某种感情）；影响",
                                        "example": "The panic in the mother's voice infected her children."
                                    },
                                    {
                                        "explanation": "2) give sb. a disease 传染",
                                        "example": "People with the virus may feel perfectly well, but they can still infect others."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "leisure",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3357d69130a061b86c384835f23c2e635e46508d_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈleʒə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] free time 空闲；闲暇",
                                        "example": "Most people only have a limited amount of leisure time."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "recovery",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a1ab606eac9542ba651fc1fd061d42110a54b65c_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈkʌv(ə)ri/【n.】 [U, sing.]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) the process of improving or becoming stronger again 改善；复苏",
                                        "example": "The economy is showing signs of recovery."
                                    },
                                    {
                                        "explanation": "2) a return to a normal state of health, mind, or strength 恢复；康复",
                                        "example": "It is hoped that Lawrence can make a full recovery from the operation."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "epidemic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/bddfd25e475c66bc79659731ee80c8026d0ce737_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌepɪˈdemɪk/【n.】 [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) a sudden increase in the number of times that sth. bad happens （坏事的突然）泛滥，蔓延",
                                        "example": "Can anything be done about this unhappiness epidemic?"
                                    },
                                    {
                                        "explanation": "2) a widespread occurrence of an infectious disease in a community at a particular time （传染病的）流行，传播",
                                        "example": "A flu epidemic is sweeping through the United States this winter."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "ultimate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/54cddc222cfbeea4e9230495814940736354f3e3_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʌltɪmət/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) being the best or most extreme example of its kind 最好的；极端的",
                                        "example": "This race will be the ultimate test of your skill."
                                    },
                                    {
                                        "explanation": "2) happening at the end of a long process 最后的；终极的",
                                        "example": " My manager will make the ultimate decision about whom to employ."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "status",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/defccc3ed241a32c6124257b984a8e4d4e790cf2_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsteɪtəs/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the social or professional position of sb. / sth. in relation to others 地位；身份；职位",
                                        "example": "Doctors have traditionally enjoyed high social status."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "badge",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fd2f1b92c1842ff3a34bf11309b6c2303d903fd5_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/bædʒ/【n.】 [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) sth. that shows a particular quality 象征",
                                        "example": "His gun was a badge of power for him."
                                    },
                                    {
                                        "explanation": "2) a small piece of metal, cloth, plastic with a picture or words on it, worn to show rank, membership of a group, support for a political idea, etc. 徽章；证章",
                                        "example": "He pulled out a badge and said he was a police officer."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "indicator",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/51e8fefce4ee34299dbc3e5e82a12848cbfc8b4c_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɪndɪˌkeɪtə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sth. that can be regarded as a sign of sth. else 指示物",
                                        "example": "All the main economic indicators suggest that trade is improving."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "absurd",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1502b87f46b06656cd3b22bd1cd73c0601ae793c_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əbˈsɜːd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "completely stupid or unreasonable 荒唐的；愚蠢的",
                                        "example": "It seems quite absurd to expect anyone to drive for three hours just for a 20-minute meeting."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "locksmith",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/bc68c380e8f8c8ca3c04112d651ba68ca21aa190_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlɒkˌsmɪθ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 锁匠"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fee",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a0c725871acc470ae6f5b7efcffb92932f103094_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/fiː/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] an amount of money paid for a piece of work or a service 报酬；服务费",
                                        "example": "Does the bank charge a fee for setting up an account?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "complain",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d6a5992800fd143e67c8c83000cb47a8e64cedab_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kəmˈpleɪn/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(not in passive) say that you are annoyed, not satisfied, or unhappy about sth./ sb. 抱怨；不满；发牢骚",
                                        "example": "Residents are complaining because traffic in this area has increased."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "regain",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/810bbdbbdfdb7c9e4278ec9b35f2fdb5547ac847_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈgeɪn/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "get back sth. you no longer have, esp. an ability or a quality 重新获得",
                                        "example": "She paused on the edge, trying to regain her balance."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "access",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b9295f6e4f2bbf375df1d34696ddb4bb25ca0ddf_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈækses/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] (~ to) the means or opportunity to approach or enter a place 接近；进入",
                                        "example": "The police managed to gain access to the house through an upstairs window."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stroll",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c992119118e942e3951d6cd5549bd6cadea85a3f_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/strəʊl/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "walk somewhere in a slow, relaxed way 散步；闲逛",
                                        "example": "We were strolling along, laughing and joking."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "leisurely",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/89fd285d9295def163aa190d0b2d179761900124_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈliːʒərli/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【ad.】without hurrying 不慌不忙地",
                                        "example": "We walked leisurely into the hotel."
                                    },
                                    {
                                        "explanation": "【a.】unhurried or relaxed 不慌不忙的",
                                        "example": "After getting up, we had a leisurely breakfast at our hotel."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "ulcer",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/efcafa042337f4df67f8ed6cf58b047eb1f1b5ab_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʌlsə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 溃疡"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fingernail",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ca64a6395a1020c55d40267c39bb5c492c9e67c8_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfɪŋgəˌneɪl/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 手指甲"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "abuse",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c99caabddec1e7128c2fd593c2c01f33b52074f0_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈbju:s/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] cruel or violent treatment of sb. 虐待",
                                        "example": "The woman suffered years of physical abuse."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "wimp",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8a52264794c88be81bc40f155108653504110bc1_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/wɪmp/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (infml.) a person who is not strong, brave, or confident 懦夫；窝囊废",
                                        "example": "The more she called her son a wimp, the less confident he became."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "luggage",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d3945db137b383e83bc6e4f1484cc192b584d7d6_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlʌgɪdʒ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] (AmE baggage) the cases, bags, etc. that you carry when you are traveling 行李",
                                        "example": "We dropped our luggage off at our hotel and went sightseeing."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "practically",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/dceb9a8d43d3623670ec50ee61c80c0f2ba3d6a0_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈpræktɪkli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "almost 几乎；差不多",
                                        "example": "She blamed me for practically every mistake in the report."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fuss",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/11d137137068ee5e40125014a9f54a0d3c5738f9_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/fʌs/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U, sing.] unnecessary excitement, worry, or activity 无谓的激动（或忧虑、活动）；大惊小怪",
                                        "example": "We tried to arrange a ceremony with as little fuss as possible."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "crush",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/465afb1f6ee41baa755823a7379bdc32b2afa8ca_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/krʌʃ/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【v.】become or make sth. full of folds or lines （使）变皱；起皱",
                                        "example": "My dress got all crushed in my suitcase."
                                    },
                                    {
                                        "explanation": "【vt.】press or squeeze sth. so hard that it is damaged or injured, or loses its shape 压坏；压伤；挤压变形",
                                        "example": "The car was completely crushed under the truck."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "self",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f328af2f6c912a3749e6690a29d6d6ff12848be2_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/self/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U, sing.] the type of person you are, including your character, your typical behavior, your abilities, etc. 自身；本身；自己；自我",
                                        "example": "Paula seemed to be her usual cheerful self a week after she came back home."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "conspiracy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1b9874ae650919eb9bccb80cfe1b12850dba623d_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈspɪrəsi/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a secret plan made by two or more people to do sth. harmful or illegal 密谋；阴谋",
                                        "example": "He was charged with conspiracy to commit criminal damage."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "airline",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/51fe7a30ff1dfcf73379303b597d114056431b98_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈeəˌlaɪn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a company that takes passengers and goods to different places by plane 航空公司",
                                        "example": "I won't fly with an airline that has a bad safety record."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "embarrass",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/144b7ee62e1133fb4fbb422d4beed2b5537c3997_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪmˈbærəs/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. feel ashamed, nervous, or uncomfortable, esp. in front of other people （尤指在社交场合）使尴尬，使窘迫",
                                        "example": "He didn't want to embarrass her by asking questions."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "embarrassment",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0e4c7cba03228fe47ba373fc0f8d1d272e4afa5d_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪmˈbærəsmənt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] a feeling of being nervous or ashamed because of what people know or think about you 尴尬；难堪；窘迫",
                                        "example": "She suffered extreme embarrassment at not knowing how to read and write."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "embarrassed",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d623c6b0d2af57709ad3a41386cd24c717c71a14_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪmˈbærəst/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "shy, awkward, or ashamed, esp. in a social situation 窘迫的；尴尬的",
                                        "example": "The girl felt embarrassed at being the center of attention."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "corridor",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6c5b83e850094a75176aee35eb67a78642e3d5b4_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkɒrɪˌdɔː/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a long narrow passage on a train or between rooms in a building, with doors on one or both sides 走廊；通道",
                                        "example": "We had to wait outside in the corridor until our names were called."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stumble",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/40d4f852323f99867d3829f501d2c72d1bae1f21_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈstʌmbl/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "trip or momentarily lose one's balance; almost fall 绊脚；绊跌",
                                        "example": "Victor stumbled over the step as he came in."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "occupy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fd7f64c43af56ee78c20e9aa569d5ffd1816a416_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɒkjʊpaɪ/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) fill or use a space, an area, or an amount of time 使用，占用（空间、面积、时间等）",
                                        "example": "The bed seemed to occupy most of the room."
                                    },
                                    {
                                        "explanation": "2) live or stay in a place 占据；居住",
                                        "example": "He occupies the house without paying any rent."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unoccupied",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/966130673fd7ac72b7b5b262efeef2e09f21f794_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ʌnˈɒkjʊˌpaɪd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "empty, with nobody living there or using it 空着的；闲置的；无人占用的",
                                        "example": "I sat down at the nearest unoccupied table in the restaurant."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "gut",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/840373c5d480aff179e405c9baafac2724b62b04_96k.mp3#duration=0.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/gʌt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~s) [pl.] (infml.) the courage and determination you need to do sth. difficult or unpleasant （做困难或不愉快的事情所需要的）勇气，魄力，决心",
                                        "example": "When failure knocks you down, will you have the guts to get up and get going?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "snap",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4a3df97144187c72e7fbb55407b73b276a5c4dd3_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/snæp/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) say sth. quickly in an angry way 厉声说（话）",
                                        "example": "There's no need to snap at me — it's not my fault that you lost your wallet."
                                    },
                                    {
                                        "explanation": "2) break or cause to break suddenly and completely, typically with a sharp cracking sound （使）啪的一声折断",
                                        "example": "You'll snap that ruler if you bend it too far."
                                    },
                                    {
                                        "explanation": "3) (infml.) take a photograph （给···）拍照",
                                        "example": "Dave snapped a picture of me and Lucas."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "lifetime",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/67cf8cfeb5e245c5ea3dd5adeee88e83024bb2a6_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlaɪfˌtaɪm/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, usu. sing.] the length of time that sb. lives or that sth. lasts 终身；有生之年；存在期",
                                        "example": "That large sum of money will last me a lifetime."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Phrases and expressions",
                "children": [
                    {
                        "word": "squeeze in",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/449defb2280293cf125b87543e8f219dd4b72983_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "manage to find time for sb. / sth. although you are very busy 为···挤出时间",
                                        "example": "How can you manage to squeeze in so much work?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "get through",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/091017f9a700c344900335c146aa908262dd613d_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "do an amount of work 完成（工作）；处理（事情）",
                                        "example": "We've got a lot of work to get through today."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "weigh down",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ee968caf34ba2fe21bbaba123513fd93508b091e_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. feel worried and upset 使忧心忡忡",
                                        "example": "The CEO felt weighed down by his responsibilities."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "take on",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0b10b329608abe2a531bba2dc3972926c2fca89a_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "undertake a task or responsibility, esp. a difficult one 接受（工作）；承担（责任）",
                                        "example": "Don't take on too much work — the extra cash isn't worth it."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "end up",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5a2ad6d8c61bb4367b5253742d3ffa07965a0039_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "be in a particular situation, state, or place after a series of events, esp. when you did not plan it （尤指经历一系列意外后）最终处于，到头来",
                                        "example": "He came round for a coffee and we ended up having a meal together."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "throw in",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/71c2e25fa4382b4dd4c184bae7faf09080f48b49_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "add sth. at no extra cost 额外赠送",
                                        "example": "Buy this book and we throw in a CD."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "in part",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e8a10b450286c1c848cbaefd02f78b1376cfdcd4_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "to some degree, but not completely 在某种程度上；部分地",
                                        "example": "Their harmonious relationship resulted in part from their similar goals."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "take off",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c6cfedbd10b6bb1664494e9d105c9f57b6ed6dec_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(of an aircraft, etc.) leave the ground and begin to fly 起飞",
                                        "example": "I felt quite excited when the plane took off from Heathrow."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "make a fuss (about sth.)",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/098b7af398a3558f0cb6124a7a070751ba6d1184_96k.mp3#duration=4.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "complain or become angry about sth., esp. when this is not necessary （因某事）大吵大闹，大惊小怪",
                                        "example": "The soup is just a bit salty. I don't know why you're making such a fuss about it."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "show up",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3a7317e974b55edc3d058e5832a90052fe767c34_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "arrive, esp. at the place where sb. is waiting for you 到达（尤指有人在等候之处）",
                                        "example": "We had 200 people show up for the conference."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "make it",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a320f9847c1daaa9663159b98640c1a30071579f_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "succeed in getting somewhere in time for sth. or when this is difficult （尤指在困难情况下）准时到达，赶上",
                                        "example": "You can still make it to the railway station if you set out right away."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "in advance (of sth.)",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/70f3dde2c893c044013ab00bf49a2bfc52f37f97_96k.mp3#duration=4.4&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "before sth. happens or is expected to happen 预先；提前",
                                        "example": "I should warn you in advance that I'm not a very good dancer."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Proper names",
                "children": [
                    {
                        "word": "Sendhil Mullainathan",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/37e41ac9dfb078cba3bddf09cbdad2af49ff428b_96k.mp3#duration=2.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌsendhɪl məlɪˈneɪθən/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "塞德希尔 &bull; 穆来纳森（美国芝加哥大学经济学教授）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Eldar Shafir",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1f448d5ff46ff59d4ae07b65f1ef95d3ee846432_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌeldɑː(r) ʃəˈfiə/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "埃尔达尔&bull;沙菲尔（美国普林斯顿大学行为科学和公共政策教授）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Thorstein Veblen",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2e056a30258973de06e2ad6cf2bc65af7b30a9c0_96k.mp3#duration=2.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌθɔːstiːn ˈvəblən/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "索尔斯坦&bull;凡勃伦（美国经济学家、社会学家）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Dan Ariely",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/42c6882c52eecf8696d6e0326f28e2eb0237dd74_96k.mp3#duration=2.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌærɪˈeli/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "丹&bull;艾瑞里（美国杜克大学行为经济学教授）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Dhahran",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3ed389c70c0da55e803c11bcba06a6682be5313f_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɑːˈrɑːn/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "宰赫兰（沙特阿拉伯东部城市）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Saudi Arabia",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e6ee89bc34b081e2bfd8152c0e71ab7c9f80afbf_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌsaʊdi əˈreɪbiə/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "沙特阿拉伯（亚洲西南部国家）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "LaGuardia",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/59189cec9cfa15df000d1627ab754575fc59f632_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ləˈgwɑːdiə/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "拉瓜迪亚机场（位于美国纽约市）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "O'Hare",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c02e2bd9bfe12c5e153ca8c8f16e54ac5644afdf_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əʊˈheə/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "奥黑尔国际机场（位于美国芝加哥市）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Chicago",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5ff9381a1d924a5cbeb84a7d3b0461bfd5353d4a_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ʃɪˈkɑːgəʊ/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "芝加哥（美国中西部城市）"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]

book1[2] = [
            {
                "name": "New words",
                "children": [
                    {
                        "word": "wrestle",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f7717a55fd07c27e0b2554cbeb4dee617d61d54f_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈresl/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "fight sb. by holding them and pulling or pushing them （与某人）摔跤，扭打",
                                        "example": "The two men wrestled with each other, and it was hard to tell who would win."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "outcome",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈaʊtˌkʌm/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] the final result of a discussion, war, etc. — used esp. when no one knows what it will be until it actually happens （讨论、战争等无法预知的）结果、后果",
                                        "example": "People who had heard the evidence at the trial were surprised at the outcome."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b523628069e95e36b2291d5fcd0694716f0d0ea2_96k.mp3#duration=1.2&t=.mp3"
                    },
                    {
                        "word": "tense",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【v.】(also 'tense up') make your muscles tight and stiff, or become tight and stiff 使（肌肉）绷紧；僵硬",
                                        "example": "Every time the phone rang, she tensed up, being afraid to hear the bad news."
                                    },
                                    {
                                        "explanation": "【a.】making you feel nervous and not relaxed, usu. because you are worried about what is going to happen 令人紧张的；令人不安的；令人着急的",
                                        "example": "There was a tense silence as everyone waited for his reaction."
                                    }
                                ],
                                "partOfSpeech": "/tens/"
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/28313a3ae228a95cf929586578f287d5fc4c6139_96k.mp3#duration=1.1&t=.mp3"
                    },
                    {
                        "word": "strain",
                        "pee": [
                            {
                                "partOfSpeech": "/streɪn/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【v.】try very hard to do sth. using all your strength or ability 使劲；竭力；用尽全力",
                                        "example": "She was straining to keep her head above the water."
                                    },
                                    {
                                        "explanation": "【vt.】injure a muscle or part of your body by using it too much or making it work too hard 拉伤；扭伤",
                                        "example": "I've strained a muscle in my leg and I have to go to hospital."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/42d08a11ebda368d9fb8c14d2618b111646919c0_96k.mp3#duration=1.3&t=.mp3"
                    },
                    {
                        "word": "wrist",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪst/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 腕（关节）",
                                        "example": "He grasped her wrist with his free hand."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f462195a30862cdeea865dff40b31ee922508879_96k.mp3#duration=1.0&t=.mp3"
                    },
                    {
                        "word": "grin",
                        "pee": [
                            {
                                "partOfSpeech": "/grɪn/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "smile widely 露齿而笑；咧着嘴笑",
                                        "example": "He walked out of the pool, grinning widely."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/651f9b34bdc258fa6f7e869a2402dc7a05d57bde_96k.mp3#duration=0.9&t=.mp3"
                    },
                    {
                        "word": "teen",
                        "pee": [
                            {
                                "partOfSpeech": "/tiːn/【n. [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (~s) [pl.] the period of your life when you are between 13 and 19 years old 青少年时期（13 到 19 岁之间的阶段）",
                                        "example": "She was in her teens when she met her boyfriend who became her husband."
                                    },
                                    {
                                        "explanation": "2) (AmE, infml.) a teenager （青）少年；十几岁的孩子",
                                        "example": "In real life, every teen can, and should, make their own decision."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a1bd7604e85b6f7f10fbdd3eb29f86125e7b3618_96k.mp3#duration=1.1&t=.mp3"
                    },
                    {
                        "word": "athletic",
                        "pee": [
                            {
                                "partOfSpeech": "/æθˈletɪk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "physically strong and good at sport 强壮的；擅长运动的",
                                        "example": "I am not a brave man, nor am I athletic."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/baf939b4561ed30e374bed139020a1afc0b8e862_96k.mp3#duration=1.2&t=.mp3"
                    },
                    {
                        "word": "athleticism",
                        "pee": [
                            {
                                "partOfSpeech": "/æθˈletɪˌsɪz(ə)m/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the ability to play sports or do physical activities well 运动能力",
                                        "example": "Except for the second game he seemed to be in control and showed some great athleticism."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/434b939031f9b62364079703bc7e077ba46ac8ed_96k.mp3#duration=1.4&t=.mp3"
                    },
                    {
                        "word": "gasp",
                        "pee": [
                            {
                                "partOfSpeech": "/gɑːsp/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【vi.】breathe quickly in a way that can be heard because you are having difficulty breathing （由于呼吸困难而）急促吸气",
                                        "example": "Brendan climbed slowly, gasping for breath."
                                    },
                                    {
                                        "explanation": "【v.】breathe in suddenly in a way that can be heard, esp. because you are surprised or in pain （尤因惊讶或疼痛而）大声吸气，倒抽气",
                                        "example": "The visitors gasped at the wonderful view."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4a306fe89a733ae3171c6419ad90216f41e88698_96k.mp3#duration=1.2&t=.mp3"
                    },
                    {
                        "word": "recall",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈkɔːl/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "remember a particular fact, event, or situation from the past 回想，回忆起（某事物）",
                                        "example": "Henry recalled that he first met Pollard during a business trip to Washington."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3ccb0861616c8a83fb8db7343ee502987db70b65_96k.mp3#duration=1.3&t=.mp3"
                    },
                    {
                        "word": "clip",
                        "pee": [
                            {
                                "partOfSpeech": "/klɪp/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "cut an article or picture from a newspaper, magazine, etc. （从报纸、杂志等上）剪下",
                                        "example": "He showed me a cartoon clipped from a newspaper."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a361b441ca4c49707a7adfd927108473bec7790b_96k.mp3#duration=1.0&t=.mp3"
                    },
                    {
                        "word": "clipping",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈklɪpɪŋ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] an article or picture that has been cut out of a newspaper or magazine 剪报",
                                        "example": "He searched through piles of letters and clippings for his mother's letter."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2313cf3229c49417055581e00276d1e57e4f0025_96k.mp3#duration=1.1&t=.mp3"
                    },
                    {
                        "word": "underline",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌʌndəˈlaɪn/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "draw a line under a word, sentence, etc. to show that it is important 在···之下画线（以示重要）",
                                        "example": "Please underline all the noun clauses in the reading passage."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/75a0c805629de55162ecb58a4b6ad7454026949b_96k.mp3#duration=1.3&t=.mp3"
                    },
                    {
                        "word": "helmet",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈhelmɪt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a strong hard hat that soldiers, motorcycle riders, the police, etc. wear to protect their heads 头盔；钢盔；安全帽",
                                        "example": "Protective helmets must be worn on the construction site."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/56db4fd36944ca669228d4eb9e356004d4db32ff_96k.mp3#duration=1.1&t=.mp3"
                    },
                    {
                        "word": "grapple",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈgræpl/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "fight or struggle with sb., holding them tightly 扭打；搏斗",
                                        "example": "Two men didn't stop grappling with a guard at the door until the police came."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c04540367b5a847915f22f72a69b8fc2b63a9d41_96k.mp3#duration=1.2&t=.mp3"
                    },
                    {
                        "word": "ritual",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈrɪtʃuəl/【n.】 [C, U]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) sth. that you do regularly and in the same way each time 惯例；老规矩；例行公事",
                                        "example": "He lights his cigar after getting up every morning and this ritual has not changed for many years."
                                    },
                                    {
                                        "explanation": "2) a ceremony that is always performed in the same way, in order to mark an important religious or social occasion （为纪念重要宗教或社会事件举行的）仪式，典礼",
                                        "example": "The lady of the house still performs the ritual of lighting candles at dinner."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/12fee918c18397e62628fb78eb3502e391687e97_96k.mp3#duration=1.2&t=.mp3"
                    },
                    {
                        "word": "competitive",
                        "pee": [
                            {
                                "partOfSpeech": "/kəmˈpetətɪv/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "having or displaying a strong desire to be more successful than others 好竞争的；求胜心切的",
                                        "example": "I could never play team sports 一 I lack the competitive spirit."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/bb60ab95f3592e4c61cbd90238f56d48a04102fc_96k.mp3#duration=1.5&t=.mp3"
                    },
                    {
                        "word": "palm",
                        "pee": [
                            {
                                "partOfSpeech": "/pɑːm/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 手掌；掌部"
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c55664c6f47ab8f0f49506ab8c9067a5258a1674_96k.mp3#duration=1.1&t=.mp3"
                    },
                    {
                        "word": "twist",
                        "pee": [
                            {
                                "partOfSpeech": "/twɪst/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "turn a part of your body around or change your position by turning 扭动（身体）",
                                        "example": "He twisted his head slightly and looked up at her."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0ecaf577842bba7136ea0ab022f82eefa2b642f7_96k.mp3#duration=1.0&t=.mp3"
                    },
                    {
                        "word": "wrap",
                        "pee": [
                            {
                                "partOfSpeech": "/ræp/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) if you wrap your arms, legs, or fingers around sth., you use them to hold it （用手臂、腿或手指）围住（某物）",
                                        "example": "He wrapped his arms around her, unwilling to leave."
                                    },
                                    {
                                        "explanation": "2) (also 'wrap up') put paper or cloth over sth. to cover it （用纸或布）包，裹（某物）",
                                        "example": "The present was beautifully wrapped in gold paper."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/575c6eb71e9c33d6cb3031a40a78af28aa9503cf_96k.mp3#duration=1.0&t=.mp3"
                    },
                    {
                        "word": "grip",
                        "pee": [
                            {
                                "partOfSpeech": "/grɪp/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, usu. sing.] the way you hold sth. tightly, or your ability to do this 紧握；紧抓",
                                        "example": "Hold the microphone in a firm grip and keep it still."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d9e2377ea8c6a967c97c3873b373ee62799ef6de_96k.mp3#duration=1.0&t=.mp3"
                    },
                    {
                        "word": "elbow",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈelbəʊ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 肘",
                                        "example": "He rested one elbow on the wall as he spoke."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/09feb50642f7cac5e92ce7f3e3a276cc114df28a_96k.mp3#duration=1.1&t=.mp3"
                    },
                    {
                        "word": "indentation",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɪndenˈteɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (also 'indent') a cut into the surface or edge of sth. 凹口；凹陷；缺口",
                                        "example": "The kid made an indentation in the center of each cookie."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9e8c0d7eeca3e66ffcc697a716d45a4406ad1930_96k.mp3#duration=1.5&t=.mp3"
                    },
                    {
                        "word": "itchy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fa92d64d1cf6e057257955767092f6681073b365_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɪtʃi/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) if clothes are itchy, they make your skin feel slightly unpleasant, so that you want to rub your skin with your nails （衣服）令人发痒的",
                                        "example": "The shirt is itchy and uncomfortable."
                                    },
                                    {
                                        "explanation": "2) if part of your body is itchy, it feels slightly unpleasant and you want to rub it with your nails 发痒的",
                                        "example": "My eyes sometimes get red and itchy in the summer."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "defeat",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6e19ea4a2bc1b30b72f31daeb86f0124e02a2576_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈfiːt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] failure to win or succeed 失败",
                                        "example": "She was a woman who hated to admit defeat."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "yield",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3880b8ef0edefaaf88648769c2b610c8ea7fa5fb_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/jiːld/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[v.]stop resisting sb. / sth.; agree to do sth. that you do not want to do 屈服；让步",
                                        "example": "He reluctantly yielded to their demands."
                                    },
                                    {
                                        "explanation": "[vt.]produce a result, answer, or piece of information 产生，得出（结果、答案或消息）",
                                        "example": "Our research has only recently begun to yield important results."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "steady",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1733c963b0f8534d27a7f137e39170990e727668_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈstedi/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) firmly held in a particular position and not moving or shaking 稳定的；牢固的；不摇晃的",
                                        "example": "Keep the camera steady while you take a picture."
                                    },
                                    {
                                        "explanation": "2) developing gradually or without stopping, and not likely to change 平稳的；持续的；逐渐的",
                                        "example": "The study also notes a steady drop in the number of college students taking science courses."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unsteadily",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a63d82bccc1bfe71dfefc23507e6b818cb372978_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ʌnˈstedɪli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "in a way that involves shaking or moving in a way you cannot control 颤抖地；抖动地",
                                        "example": "I walked unsteadily to another room and looked outside."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unexpected",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5bdd4cc8378c5f2a24a6ee8502dca5d7f94e493e_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌʌnɪkˈspektɪd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used to describe sth. that is surprising because you were not expecting it 想不到的；意外的；突然的",
                                        "example": "The experiment with new methods produced some unexpected results."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "handshake",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a83958bc7c81e6ad12136a9bbf137cdb65a78fc0_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈhændʃeɪk/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] the act of taking sb.'s right hand and shaking it, which people do when they meet or leave each other or when they have reached an agreement 握手",
                                        "example": "He greeted me with a firm handshake."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "suck",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/05e070f5a92e0e7ff51f0479c7e6096641edbe6b_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/sʌk/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "take air, liquid, etc. into your mouth by making your lips form a small hole and using the muscles of your mouth to pull it in 吸；吮；啜",
                                        "example": "He sucked hard for air to keep breathing."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "brace",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e3c5e2e2efa2f86c7c27f50f67d66ef86380d319_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/breɪs/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ oneself / sb. for) mentally or physically prepare yourself or sb. else for sth. unpleasant that is going to happen （使）准备迎接（令人不快的事）",
                                        "example": "Nancy braced herself for the inevitable arguments during the meeting."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "embrace",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ad9fe72314f08dbdd1ffa657f29cca0dadac9dfc_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪmˈbreɪs/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【n.】[C] the act of holding sb. close to you, esp. as a sign of love 拥抱",
                                        "example": "They held each other in a tender embrace."
                                    },
                                    {
                                        "explanation": "【v.】put your arms around sb. and hold them in a friendly or loving way 抱；拥抱",
                                        "example": "The couple were sort of crying for joy and embracing each other."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "throat",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1c90bce0fba08492be2a6d741a9be8fe8861eaa5_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/θrəʊt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 喉咙；咽喉"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sadness",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3120bdfbac64808a7e60379ef6e2167574e70299_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsædnəs/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the state of feeling sad 悲伤；悲痛",
                                        "example": "It was with great sadness that we learned of his death."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dresser",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d2cc9f5bdc4e5684b854df7a43e04ee1096572b0_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdresə/ 【n.】 [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) a low table with a mirror where one sits while applying makeup 梳妆台",
                                        "example": "Mary took the watch out of her dresser and put it on."
                                    },
                                    {
                                        "explanation": "2) a piece of furniture with drawers for storing clothes, sometimes with a mirror on top 衣橱",
                                        "example": "He put the pants in the dresser and went to bed."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sling",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3449d3a66947a43bc2415a9090b374ae18f090b0_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/slɪŋ/ 【vt.】 (slung, slung)",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) hang sth. loosely （松松垮垮地）挂，吊，悬",
                                        "example": "She likes to wear a belt slung around her waist."
                                    },
                                    {
                                        "explanation": "2) throw or put sth. somewhere with a careless movement and some force （随意而稍用力地）拐，掷，抛",
                                        "example": "He stood up and slung his gun over his shoulder."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "oversized",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d65a370862a0ea0d827c2c2f6006c111604cf9bb_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌəʊvəˈsaɪzd/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "bigger than usual or too big 大于一般的；太大的",
                                        "example": "I'm sorry. Your parcel is a bit oversized."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sunglasses",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/25256d3c2073a287495c2859fb3f574fc11945b8_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsʌnˌglɑːsɪz/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[pl.] 太阳镜；墨镜"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "entire",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/62da371323bab2ab1b7b49d4f18110d793cd24ac_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈtaɪə/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) used when you want to emphasize that you mean all of a group, period of time, amount, etc. 全部的；整个的",
                                        "example": "He was so tired that he slept through the entire movie."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "porch",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/77196631c57bdbdf3268bee5a8361add5a512e4c_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/pɔːtʃ/ 【n. [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (AmE) a structure built onto the front or back entrance of a house, with a floor and a roof but no walls （房屋前后的）游廊，走廊；阳台"
                                    },
                                    {
                                        "explanation": "2) (BrE) an entrance covered by a roof outside the front door of a house or church （房子或教堂前门外有顶的）入口，门廊"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "carton",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f1b6c9f67b2e5183514229b3a6b71c7174b108a6_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkɑːtn/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a small box made of cardboard or plastic that contains food or a drink 硬纸盒；塑料盒",
                                        "example": "She was so thirsty that she drank a carton of orange juice."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "rewind",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b003f22de8619ac826305f7d658cafff33b3941c_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌriːˈwaɪnd/ 【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(rewound, rewound) make a cassette tape or video go backward in order to see or hear it again 倒回（录音带或录像带）",
                                        "example": "He rewound the tape and replayed a few pieces."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sip",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b36aec78dbc38825cb291bbb20131d7e410a9497_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/sɪp/ 【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "drink sth. slowly, taking very small mouthfuls 小口地喝；抿；呷",
                                        "example": "She was sitting at the table sipping her coffee."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "patio",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6ab46827ee08e0af3297891b57b84e61b7e09775_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈpætiəʊ/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (pl. patios) a flat hard area near a house, where people sit outside （房屋外面的）露台，平台"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "seagull",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/79127b36db1194233c6d27e476f135ddad82df62_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsiːˌgʌl/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 海鸥"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "rail",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ddcbd29d0b2273166690f19f51e26eaaccdcc69b_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/reɪl/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the railway system 铁路系统"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "obligation",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e0e11ab7197f3564b3283029129965867c15f0d7_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɒblɪˈgeɪʃn/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a moral or legal duty to do sth. （道义或法律上的）义务，职责，责任",
                                        "example": "Employers have an obligation to treat all employees equally."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "reassure",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4eeb0b5ac784a3776c5e2c67cbed10b4e1ebe4cf_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌriːəˈʃʊə/ 【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. feel calmer and less worried or frightened about a problem or situation 使安心；使放心；使消除疑虑",
                                        "example": "He tried to reassure me, but I still felt anxious."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "handwritten",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6679e4dd7dc08adf2aa187bfe14febde23d17e0d_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌhændˈrɪtn/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "written by hand, not printed 手写的",
                                        "example": "Would you like the essay typed or handwritten?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "shamelessly",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ab743bbc985326fd33dd6cc0cce75e529638b2ca_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʃeɪmləsli/ 【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "without feeling ashamed of your bad behavior although other people think you should be ashamed 无耻地；不知羞耻地",
                                        "example": "He shamelessly abandoned the project when he realized he would not gain any benefits from it."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "drunk",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ed4005e399e53858c810ee6c56663c51ca43e7f7_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/drʌŋk/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(not before noun) unable to control your behavior, speech, etc. because you have drunk too much alcohol 喝醉的",
                                        "example": "David got drunk and I had to take him home and put him to bed."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "thunderstorm",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4b45fb9fb3a1204412d7ca90971e750854b32481_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈθʌndəˌstɔːm/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a storm with thunder and lightning 雷暴",
                                        "example": "Eventually, the thunderstorm stopped and we saw a beautiful rainbow in the sky."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "cuddle",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/456a0c29b2e600a1b41cd193b3a1b9bf9f5ee775_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkʌdl/ 【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "hold sb. / sth. very close to you with your arms around them, esp. to show that you love them （尤指表示喜爱而）抱，拥抱，搂抱",
                                        "example": "Dawn and her boyfriend were cuddling on the sofa."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dependent",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4098e8e80e368d52bb3d03582cc937b48c1ce3e2_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈpendənt/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (be ~ on / upon) be directly affected or decided by sth. else 取决于某物",
                                        "example": "Your pay is dependent on how much you produce."
                                    },
                                    {
                                        "explanation": "2) needing sb. / sth. in order to survive or be successful 依靠的；依赖的",
                                        "example": "You can't be dependent on your parents all your life."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Phrases and expressions",
                "children": [
                    {
                        "word": "pick up",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b2a54fa8463d1b229aec62389288b3fa8cd7545d_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "let sb. get into your car, boat, etc. and take them somewhere 搭载；接载",
                                        "example": "I'll pick you up at the station and take you to the dinner party afterward."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "work against",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f4730d1c4e9e87a26eb985fec8676f9377789963_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "work effectively toward countering or defeating sb. / sth. 有效地对抗；击败",
                                        "example": "I heard that pepper spray works well against bears."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "lift off",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a304a697cbe8170428bb119a58bb961eacea757e_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if an aircraft or spacecraft lifts off, it leaves the ground and rises into the air （飞机）起飞；（航天器）升空",
                                        "example": "The aeroplane lifted off at noon for New York with more than 100 passengers."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stay up",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ebbc58166c8e2675f9002f5ba4d9b951d8f77601_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "not go to bed at the time you would normally go to bed 熬夜；深夜不睡觉",
                                        "example": "With so much homework to do, I will have to stay up late tonight."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "settle for",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/adf712606f7b113b1f0e700c37133c87c48bffa1_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "accept sth. even though it is not the best, or not what you really want 勉强接受；将就",
                                        "example": "They want $2,500 for it, but they might settle for $2,000."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "within walking distance",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6e556569231cd00a04f81031109b186cdcfbf019_96k.mp3#duration=2.5&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "near enough to walk to easily 在步行距离之内",
                                        "example": "She used to live within walking distance of her children."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "on one's mind",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/156419f57b7bbbc08e3f1651de79e0e35ffa71f9_96k.mp3#duration=2.2&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if sth. is on your mind, you keep thinking or worrying about it 挂在心上的；惦念的",
                                        "example": "He looked as though he had something on his mind."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "at the top of one's lungs",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/10e67466912163f2754743597f886ba1e3391b6a_96k.mp3#duration=2.8&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "as loudly as possible 尽量大声地；放声地",
                                        "example": "He came running up to me screaming at the top of his lungs, \"I love you!\""
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "cuddle up",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a495557da989f6dfbba9ccb368646b93d9953ca0_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "lie or sit very close to sb. / sth. 偎依",
                                        "example": "We cuddled up together to keep out the cold."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Proper names",
                "children": [
                    {
                        "word": "Netflix",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/bc87e6334ccd636dde027d6634c381f5115a3ed1_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈnetflɪks/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "网飞（在线影片租赁提供商，总部位于美国加利福尼亚州）"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]

book1[3]= [
            {
                "name": "New words",
                "children": [
                    {
                        "word": "browse",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/73126474b3512b23bd1204af0570dbbfc38d4140_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/braʊz/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ through) look through the pages of a book, magazine, etc. without a particular purpose, just looking at the most interesting parts 随意翻阅，浏览（书刊等）",
                                        "example": "I was browsing through a magazine at the station bookstall when I saw Susan."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "longing",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9a5a25e03378e429c6d76ddb48b8927d020c577a_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlɒŋɪŋ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U, sing.] a strong feeling of wanting sb. / sth. 渴望；盼望",
                                        "example": "Spending the holiday alone in a foreign country, she had a sudden desperate longing for home."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "aisle",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/641881a9f689af54c187ba31b1555540e94f1bb7_96k.mp3#duration=0.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/aɪl/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a long passage between rows of seats in a church, plane, theater, etc., or between rows of shelves in a shop 通道；过道",
                                        "example": "Madam, would you like a window seat or a seat next to the aisle?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "flick",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f33de3f87a54e2f60dda7e705e53c63a2e41e5fb_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/flɪk/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sth. move quickly and suddenly, esp. with a quick movement of the hand （尤指用手快速地）轻击， 轻拍，轻拂，轻弹",
                                        "example": "The kid flicked the screen of the iPad to find something interesting."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "restlessly",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7fe0d4b0acd281349c551b1dec1179d67110ab36_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈrestləsli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "in a way that is unwilling to keep still or stay where you are, esp. because you are nervous or bored （尤指因紧张或厌烦而）不安宁地，烦躁地，不耐烦地",
                                        "example": "He stood up and moved about in the room restlessly."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fatigue",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/24899284642103e229ebfefacebbe64d0635ea79_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/fəˈtiːg/【n.】 [U]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (usu. after another noun) a feeling of not wanting to do a particular activity any longer because you have done too much of it 厌倦",
                                        "example": "Too many requests for aid can cause compassion (同情心) fatigue."
                                    },
                                    {
                                        "explanation": "2) very great tiredness 疲劳；疲乏；劳累",
                                        "example": "He was suffering from mental and physical fatigue because of his father's illness."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "paralysis",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ff81145bed5b34ee2bf8c65d86314944e7ce5f30_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/pəˈræləsɪs/【n.】 [U]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) a state of being unable to take action, make decisions, or operate normally 不知所措；（行动、 决策、运行等）瘫痪，停顿",
                                        "example": "The country was on the verge of complete paralysis due to the strike."
                                    },
                                    {
                                        "explanation": "2) the loss of the ability to move all or part of your body or feel things in it 瘫痪；麻痹",
                                        "example": "A stroke can cause paralysis and difficulties with speech in the patient."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "donkey",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7dde86424c58b2527ef3e3946c248d75910c11dd_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdɒŋki/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 驴"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unable",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/176d50510b2bccf3917781cd44c4f263eba5cb25_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ʌnˈeɪbl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(not before noun) not able to do sth. 无能力（做某事）的",
                                        "example": "Many teenagers feel that they are unable to talk to their parents about their problems."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "hay",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cd106ce108bcb463747ae2f738f0f2d8dcda829c_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/heɪ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U]（作动物饲料用的）干草，饲草"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "boast",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/168810de3c288b2f8b54ad3464512b3d7a887ce2_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/bəʊst/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ about / of) talk too proudly about your abilities, achievements, or possessions 夸口；夸耀；吹嘘",
                                        "example": "Andrew often boasts of his success in investing in real estate."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fingertip",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/22895060dbaf6525dc60db37affc7c40160914cc_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfɪŋgəˌtɪp/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 指尖"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "confusion",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/bccd30d68091c2a706fbc8b3b1f4dc952bb0f1c4_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈfjuːʒən/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] when you do not understand what is happening or what sth. means because it is not clear 困惑；不确定；混乱",
                                        "example": "There is a great deal of confusion about how the new machine works."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "replicate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c45c8a1afe3b1cad94f568a894f0cb7ab5dfbea1_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈreplɪˌkeɪt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(fml.) if you replicate sb.'s work, a scientific study, etc., you do it again, or try to get the same result again 重做；重复（某项科学研究）；复证（某个结果）",
                                        "example": "There is a need for further research to replicate the findings of Professor Thompson and his team."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "pension",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ef7130c46d94632f30c3fc172010516e5602677d_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈpenʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] an amount of money paid regularly by the government or company to sb. who does not work anymore, for example because they have reached the age when people stop working or because they are ill 养老金；退休金",
                                        "example": "If you are self-employed, can you enjoy a pension after retirement?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "motivate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/17881f9ba20829d0cc827e52ac50c6c2d88c312d_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈməʊtɪˌveɪt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) make sb. want to achieve sth. and make them willing to work hard in order to do this 激发；激励；促动",
                                        "example": "A good teacher has to be able to motivate their students."
                                    },
                                    {
                                        "explanation": "2) be the reason why sb. does sth. 成为···的动机",
                                        "example": "Was he motivated by a desire for power?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "demotivate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e397df78c891edbf1e37aa7c565cb4ce9345c872_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/diːˈməʊtɪˌveɪt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. less eager to work or study 使人失去动力；使人消极",
                                        "example": "The new policy can create insecurity and demotivate staff."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "cyberspace",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1ec40ecf8e1617b63b20ecbcfbf58ad9f2fac671_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsaɪbəˌspeɪs/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] all the connections between computers in different places, considered as a real place where information, messages, pictures, etc. exist 网络空间",
                                        "example": "The laws of privacy and copyright still apply in cyberspace."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stack",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8e8ea193590ed9bda4b3844b5bb2554ae94e8e9f_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/stæk/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "v.(also 'stack up') make things into a neat pile, or form a neat pile （使）整齐地堆起；摞起",
                                        "example": "The shop assistants price all kinds of ice cream before stacking them in the freezer."
                                    },
                                    {
                                        "explanation": "n.[C] a neat pile of things 一叠；一堆；一摞",
                                        "example": "Next to the bottles was a tall stack of plastic cups."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "realm",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7bae73901e2bb1f0b316b2f80e0d9b779aafea75_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/relm/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] (written) a general area of knowledge, activity, or thought （知识、活动、思想的）领域，范围",
                                        "example": "This concept first appeared in the realm of science fiction a hundred years ago."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "annoy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e0fb2e288d237e98d22767c8ded03895105f85a3_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈnɔɪ/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. feel slightly angry and unhappy about sth. 使恼怒；使生气",
                                        "example": "What annoyed him most was that he had received no apology."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "annoying",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2e113ffa8426935ccfe3e5314e5b5afef82807b1_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈnɔɪɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "making you feel slightly angry 讨厌的；令人气恼的",
                                        "example": "It is annoying that he didn't tell us anything about the plan before."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dominance",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/daadd8fcae9a4385f9a406d0f499beaee01dc5bc_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdɒmɪnəns/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the fact of being more powerful, more important, or more noticeable than other people or things 优势；显要；突出",
                                        "example": "TV has had dominance over other media for many decades in broadcasting news."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "format",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/04c401d5a46d725b36cf3a13ef625188ff3a65ae_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfɔːmæt/【n.】 [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) the way in which information is stored on a computer （计算机信息存储）格式",
                                        "example": "These images are stored in a digital format within the database."
                                    },
                                    {
                                        "explanation": "2) the general arrangement, plan, design, etc. of sth. 总体安排；计划；设计",
                                        "example": "The format of the new quiz show has proved popular."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "boom",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1ee72a66e68dc27093735b2201224b728be19db0_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/buːm/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[sing.] a quick increase of business activity （生意）繁荣，兴旺，激增",
                                        "example": "The economic boom in the past decade has created many job opportunities in this country."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "revenge",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/13c787a6b345d1aa06a6e48e71dd52bec14d8c11_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈvendʒ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] sth. you do in order to punish sb. who has harmed or offended you 报复；报仇",
                                        "example": "Caesar returned to Rome to take a terrible revenge on his enemies."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "analog",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/799e6652c22abb38f4a9620d080d99fc19c7b137_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈænəˌlɒg/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(BrE analogue) a thing that is similar to another thing 相似物；类似情况",
                                        "example": "No artificial model can ever be a perfect analog of nature itself."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "appeal",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f71ebafec346ec7d46263796218faca1c848a387_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈpiːl/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [U] a quality that makes people like sb. / sth. 感染力；吸引力",
                                        "example": "The long beach and clear water are the particular appeal of this island."
                                    },
                                    {
                                        "explanation": "2) [C] an urgent request for sth. important 呼吁；恳求",
                                        "example": "The missing girl was found yesterday after a nationwide appeal for help."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "define",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8df9b9b8306b399a813e4e88e332a1ebbc4a3ca5_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈfaɪn/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "describe sth. correctly and thoroughly, and say what standards, limits, qualities, etc. it has that make it different from other things 确定；说明；界定",
                                        "example": "It is vital for the seller to have the ability to define buyers' needs."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "lower",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/32d2b117939809e4838295e67c8e6113cc38275f_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈləʊə/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "reduce sth. in amount, degree, strength, etc., or become less 降低；减少",
                                        "example": "I think we should lower the price to make our product more competitive."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "approval",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ee94165a7f4be7bd6257be8d62748a3639440e13_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈpruːvl/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [U] (fml.) when sb. likes sb. / sth. and thinks that they are good 赞许；赞成；同意",
                                        "example": "The children longed for a sign of approval from the teacher for what they had done."
                                    },
                                    {
                                        "explanation": "2) [C, U] when a plan, decision, or person is officially accepted 批准；认可",
                                        "example": "It is just two months since we received official approval to go ahead with the project."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fist",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0de23e3fe23f6ba2e975ea42fa3da7b47ff4da0b_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/fɪst/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 拳头"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "invincible",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3cde0cff6218b5aaf67dd7da5f7549c08b197b1f_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈvɪnsəbl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "too strong to be destroyed or defeated 不可战胜的；无敌的",
                                        "example": "She seemed nearly invincible on the tennis court this year."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "foyer",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/85cc98d36810a033e21dd41767df8af60faf2176_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfɔɪeɪ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a room or hall at the entrance to a public building （公共建筑物入口处的）休息厅，门厅",
                                        "example": ""
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "high-rise",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c9ce6f9eeed13a483046455767217a5b4b094e99_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈhaɪ ˌraɪz/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) tall with many levels 高耸的；高层的",
                                        "example": "Their office is in a high-rise building in the center of the city."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dusk",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/852f445e60ffb7070212951e75d353b93175eb8c_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dʌsk/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the time before it gets dark when the sky is becoming less bright 黄昏；傍晚",
                                        "example": "She likes to sit in the garden at dusk, listening to her favorite band."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "trickle",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c6532b0976151524d5c8bebb67093c55def97646_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtrɪkl/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) if people, vehicles, goods, etc. trickle somewhere, they move there slowly in small groups or amounts （人、车辆、货物等）缓慢而零星地移动",
                                        "example": "A few fans started to trickle into the stadium where the concert was to be held."
                                    },
                                    {
                                        "explanation": "2) if liquid trickles somewhere, it flows slowly in drops or in a thin stream 滴；淌；涓涓地流",
                                        "example": "She could feel the sweat trickling down her back."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "scribble",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d022b86ef299077b9b62c760e918538f6163d603_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈskrɪbl/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(also 'scribble down') write sth. quickly and untidily 潦草地写",
                                        "example": "You can scribble your own ideas in the blank areas provided."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "arrow",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d6e542b68377a1d5060a2aced25d567789f9cb52_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈærəʊ/【n. [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) a sign in the shape of an arrow, used to show direction （指示方向的）箭号，箭头（符号）",
                                        "example": "Follow the arrows on the ground and you can find the school library easily."
                                    },
                                    {
                                        "explanation": "2) a weapon usually made from a thin straight piece of wood with a sharp point at one end, that you shoot with a bow 箭；矢",
                                        "example": "Cupid shot an arrow at William and he fell in love with Joanna at first sight."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "brainstorm",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/50b9776d7b1b8a7759e1ad978d8b0119daf21cf2_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈbreɪnˌstɔːm/【n. [C, usu. sing.]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) the act of trying to develop ideas and think of ways to solve problems 头脑风暴",
                                        "example": "Unless we have a brainstorm, I don't see how we're going to get out of this situation."
                                    },
                                    {
                                        "explanation": "2) (AmE) a sudden clever idea 灵感；突然想到的妙计",
                                        "example": "Kate had a sudden brainstorm after days of deep thinking."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "halfway",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b2c2db83e3e86323efe0e6b353e903a7ac473072_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌhɑːfˈweɪ/【a.&ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "at a middle point in space or time between two things （空间或时间的）中间（的），半途（的）",
                                        "example": "We stopped at the highway service area halfway through the journey for a drink and some rest."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "consult",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c96b98c68bf6f12e27c7e53754b02b13a8925e93_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈsʌlt/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) give professional advice to a person, organization, or company for a fee 当顾问",
                                        "example": "She consults on law for a living after she graduated with a master's degree."
                                    },
                                    {
                                        "explanation": "2) ask for information or advice from sb. because it is their job to know sth. 咨询；请教",
                                        "example": "As with any medicine, please consult your doctor before taking."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "oyster",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/00b051a00273396fd6314946580a6fda6f237209_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɔɪstə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 牡蛎；蚝"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "argument",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/566778a39f7fd1413b985c490e5279c66fcc35c8_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɑːgjʊmənt/【n. [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) a set of reasons that show that sth. is true or untrue, right or wrong, etc. 论点；论据",
                                        "example": "We need to provide a convincing argument as to why the system should be changed."
                                    },
                                    {
                                        "explanation": "2) a situation in which two or more people disagree, often angrily 争论；争吵；争辩",
                                        "example": "There have been a lot of arguments about who was responsible for the accident."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "management",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a65ff5cb91f33d8bc5dda85e5891f636bdec7ed6_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmænɪdʒmənt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the activity of controlling and organizing the work that a company or organization does （对公司或组织的）经营，管理",
                                        "example": "The company went bankrupt due to a lack of management skills."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "straddle",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c204f9fb860fbf1ece85f02dbdea30887058fcd7_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈstrædl/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) include different areas of activity, groups, time, etc. 包括，跨越（不同的活动领域、团体、时间等）",
                                        "example": "She is experimenting with a new style which straddles classic and modern art."
                                    },
                                    {
                                        "explanation": "2) sit or stand with your legs on either side of sb. / sth. 跨坐；跨立",
                                        "example": "The photo shows him dressed in leather, straddling a motorbike."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "invest",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/56f95cf74434c486ffbc34f9421999a7758799a6_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈvest/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (~ in) use a lot of time, effort, etc. or spend money in order to make sth. succeed 投入（大量时间、精力、金钱等以成就某事）",
                                        "example": "Elizabeth finds it necessary to invest a lot of time in learning new skills."
                                    },
                                    {
                                        "explanation": "2) buy shares, property, or goods because you hope that the value will increase and you can make a profit 投资",
                                        "example": "I've got a few thousand dollars I'm looking to invest."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "existential",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6a0bd80b71997a8cf6513646eb1452107fd9f20b_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌegzɪˈstenʃl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(fml.) (only before noun) relating to the existence of humans or to existentialism 关于人类存在的；存在主义的",
                                        "example": "He holds the existential notion that man is in control of his own life."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "gratefully",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/11ec70ebf96ea3c901500c9eb53bd8523eeaaeb7_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈgreɪtfli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "in a way that you feel you want to thank sb. because of sth. kind that they have done, or to show this feeling 感谢地；感激地",
                                        "example": "All contributions to the disaster areas will be gratefully received."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "executive",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/68116370dd3b3a0b1d32a9995050d7bc6444790e_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪgˈzekjʊtɪv/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a manager in an organization or company who helps make important decisions （机构或公司的）主管，经理",
                                        "example": "As an executive, he made some important decisions and gradually led the company to the track of rapid progress."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "educational",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e2c376194327545ab0c23f3c2862c163974699bd_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌedjʊˈkeɪʃn(ə)l/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "relating to education 教育的",
                                        "example": "This institution offers a wide range of educational and sports activities."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "abundant",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/10c5b6ace413f62c9235393435b770464f4453d4_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈbʌndənt/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "sth. that is abundant exists or is available in large quantities so that there is more than enough 充裕的；丰富的",
                                        "example": "This country has an abundant supply of natural resources."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "consultation",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2788bf2aeeef21a8b1171e3ac4a8b2afb4efd961_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌkɒnslˈteɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a discussion in which people who are affected by or involved in sth. can give their opinions 商量，磋商；咨询",
                                        "example": "The decision was reached after consultation with her parents and teachers."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "assumption",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/93abce3084130ff80420f57173874b4bc7e4a833_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈsʌmpʃn/【n.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sth. that you think is true although you have no definite proof 假定；假设",
                                        "example": "You are making an assumption that might not be true."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "necessity",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/539e7b2bcf42dd76edd77e8ba3adc93741f654e1_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/nəˈsesəti/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sth. that you need to have in order to live 必需品",
                                        "example": "A lot of families could not even afford to buy the basic necessities of life during that period of time."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "logically",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/81b4797a2acbecc17bba810e8fde99cd1aa69368_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlɒdʒɪkli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "in a way that facts and ideas are connected in a correct way in the thinking process 按照逻辑地；合乎逻辑地",
                                        "example": "At the meeting, Sarah presented her ideas about the new product clearly and logically."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sacrifice",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/22c7de0f9c81024ccdd00256d5f49526519448b8_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsækrɪˌfaɪs/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "willingly stop having sth. you want or doing sth. you like in order to get sth. more important 牺牲；献出",
                                        "example": "He sacrificed a promising career in his 30s to look after his kids."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "surrender",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/00c0edc31b9ebf22d75a610a36a963579ac8a994_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/səˈrendə/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) give up sb. / sth., esp. because you are forced to （被迫）放弃",
                                        "example": "People believed that Bayer has surrendered his artistic identity in his later films."
                                    },
                                    {
                                        "explanation": "2) say officially that you want to stop fighting, because you realize that you cannot win 投降",
                                        "example": "The rebel soldiers were forced to surrender."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stuck",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/aaafafe4b140be6bed4d90d8baef871155395d04_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/stʌk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) not knowing what to do in a particular situation 不知所措的；（为某事）犯愁的",
                                        "example": "If you're stuck for something to do tonight, come out with us."
                                    },
                                    {
                                        "explanation": "2) impossible or unable to move from a particular position 卡住的；无法移动的；动不了的",
                                        "example": "Sara tried to open the window but it was stuck."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "simultaneously",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f4eb7664532e5b8b2ad9192a9b690f9c1cf9d796_96k.mp3#duration=2.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌsɪmlˈteɪniəsli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "at exactly the same time 同时发生地；同步地",
                                        "example": "The concert will be broadcast simultaneously on television and radio."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "contradictory",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b5852acaabe8d07b64d4b1bab71e8d8a9a1cdcb6_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌkɒntrəˈdɪkt(ə)ri/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "two statements, beliefs, etc. that are contradictory are different and therefore cannot both be true or correct 矛盾的；抵触的",
                                        "example": "The witnesses gave two completely contradictory accounts, so we don't know which one should be trusted."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Phrases and expressions",
                "children": [
                    {
                        "word": "stick with",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e98d0a1e81936cf465f856267f3a51b25eaa97f6_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(infml.) continue doing sth. the way you did or planned to do before 继续做（使用）；不放弃",
                                        "example": "Let's stick with the original plans we decided together."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "have sth. at one's fingertips",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2d515a29c96490f557acd087528f5e4a0af8ef74_96k.mp3#duration=3.0&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "have knowledge or information ready and available to use very easily 手头有某物（可供随时使用）；对某物了如指掌",
                                        "example": "We have all the facts and latest figures about the application at our fingertips."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "set in",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8412a447ad57b19f87127bec4f9f5dd7e9664228_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if sth. sets in, esp. sth. unpleasant, it begins and seems likely to continue for a long time （尤指不愉快的事）开始，来临",
                                        "example": "Winter seems to be setting in rather early this year."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "the world is sb.'s oyster",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5a470ab9bc0bd54e1221dbb6bddbeb91b9d1d7a2_96k.mp3#duration=3.2&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used to tell sb. that they can achieve whatever they want 可以随心所欲；想要什么就能得到什么",
                                        "example": "With a doctoral degree and a mathematical talent, the world is her oyster."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fit in",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cff4d927f864b1224cbbb9ad719896e58af40f10_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "manage to do sth. or see sb., even though you have a lot of other things to do 安排时间做（某事）；安排时间见（某人）；找出···的时间",
                                        "example": "I wanted to fit in a swim before breakfast, since I would be fully occupied the whole day."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "in passing",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/920828e1c393ed77ccfba0f715aa7470f3a35203_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if you say sth. in passing, you mention it while you are mainly talking about sth. else （在谈论别的事情时）顺便说起某事物，附带提及某事物",
                                        "example": "Sampson mentioned in passing Emma's strange behavior at yesterday's party."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "by default",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2a02b9dc958f5d34277969f3f33fbec6cb198bec_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if sth. happens by default, it happens because you did not do anything to change it 由于没有采取行动（而发生某事）",
                                        "example": "I became a teacher by default rather than by design."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "step in",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/629c8f767184da4e8676fbbf8cdd5cf61e131417_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "become involved in an activity, discussion, or disagreement, sometimes in order to stop trouble 介入；干涉；插手",
                                        "example": "An outside buyer has stepped in to save the company from going out of business."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Proper names",
                "children": [
                    {
                        "word": "Indian Ocean",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/08af199fa1d5986e02376a19aeda0677eda0ce6e_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɪndiən/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "印度洋"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Apple Music",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/20724f2c63d132cf54a140266d51d46712230f8e_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "苹果音乐（苹果公司推出的流媒体音乐服务）"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]

book1[4] = [
            {
                "name": "New Words",
                "children": [
                    {
                        "word": "alley",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2a73f9002559ed63ab18410a65bc7b79f141e89b_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈæli/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (also 'alleyway') a narrow street between or behind buildings, not usually used by cars 小巷； 胡同",
                                        "example": "A narrow alley led up between the houses to the main street."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "layout",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d12c16d84998c1bce24399270ab0b408d01dde5e_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈleɪaʊt/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] the way in which the parts of sth. such as the page of a book, a garden, or a building are arranged 布局；布置；设计；安排",
                                        "example": "All the flats in the building have the same layout."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "neighborhood",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c12469e528b45c7d11211588977e90be9351f612_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈneɪbəˌhʊd/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (BrE neighbourhood) a district or an area of a town 街区；城区",
                                        "example": "Jessica and Jason grew up in the same neighborhood of Boston."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "excitement",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/bc7daf04adc96aa4c7d06506c9c6673101e26f61_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪkˈsaɪtmənt/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the state of feeling excited 激动；兴奋；刺激",
                                        "example": "The children were filled with excitement at the thought of visiting Disneyland."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "spirited",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cef322d4b332eadc9951ea7d066411cee3a85856_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈspɪrɪtɪd/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "having energy and determination 精神饱满的；生气勃勃的；有决心的",
                                        "example": "At the end of the day, the usually cheerful and spirited girl was worn out."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "tile",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/924a3b1052f116a0615201f20d6bc34d4872c4c8_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/taɪl/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] （铺屋顶的）瓦，瓦片"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "characteristic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9064decc0cef4cab021384e65257c308065526fe_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌkærɪktəˈrɪstɪk/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ of) very typical of a particular thing or of sb.'s character 典型的；独特的",
                                        "example": "Personality is often defined as an individual's characteristic way of thinking, feeling, and behaving."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "impress",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2b909193360f8fdd7d677fb4726dc76c8d2a5917_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪmˈpres/ 【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. feel admiration and respect 使钦佩；使留下深刻印象",
                                        "example": "None of the people I've interviewed so far has impressed me."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "distinguish",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e23e4e8f559f3dc82f15c6ca853ff60e22367ba3_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈstɪŋgwɪʃ/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【vt.】be the thing that makes sb. / sth. different or special 使有区别；使有特色",
                                        "example": "The factor that distinguishes this company from its competitors is customer service."
                                    },
                                    {
                                        "explanation": "【v.】recognize and understand the difference between two or more things or people 区分； 辨别",
                                        "example": "At what age are children able to distinguish between right and wrong?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "connection",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f39d5185411a71b663c1a94da06892d36c1377b2_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kəˈnekʃn/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] the way in which two facts, ideas, events, people, etc. are related to each other, and one is affected or caused by the other 联系；关联",
                                        "example": "There is a connection between pollution and the death of trees."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "commune",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e2ee560edaa5f3050ce13b98fca780689fc9440c_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkɒmjuːn/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] A group of people who live together and who share the work and their possessions 群居团体；社区",
                                        "example": "She went to California and joined a commune."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "communal",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2bf9fff29c2fd0e5843c1a2bcc0c2c9d45bd4fe8_96k.mp3#duration=3.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkɒmjʊnl; kəˈmjuːnl/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "shared by a group of people or animals, esp. a group who live together （为同一群体所）共有的，共用的，共享的",
                                        "example": "As a student he tried communal living for a few years."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "including",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/aab4065b66eb1845c8ae21bb246fc897448b36b8_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈkluːdɪŋ/ 【prep.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "having sth. as part of a group or set 包括···在内",
                                        "example": "I've got three days' holiday including New Year's Day."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Westerner",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/edda2d532c1d161a52b86be5c54150c3665c742d_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈwestənə/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb. from the western part of the world 西方人；西洋人；欧美人",
                                        "example": "What is difficult for Westerners to understand is the real meaning of these cultural customs."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dawn",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0e16bff49bedb3e11b1bc0c59fcd3f5c57719cb5_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɔːn/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] the time at the beginning of the day when light first appears 黎明；破晓",
                                        "example": "I don't think he went to sleep until dawn."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "outdoor",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2f902f900534d137f5487e32760a9af0ae7d05d6_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌaʊtˈdɔː/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) existing, happening, or used outside, not inside a building （在）户外的；用于户外的",
                                        "example": "I love outdoor activities such as walking and camping."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "cheerful",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6f91c30bcbd1f44108616eb83f554262e587093b_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtʃɪəfl/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "happy, or behaving in a way that shows you are happy 高兴的；兴高采烈的",
                                        "example": "Before the accident he had been cheerful and confident."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "matchmaker",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2de87685af05615c8eaeabbabfda0be757a9785b_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmætʃˌmeɪkə/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb. who tries to find a suitable partner for sb. else to marry 媒人",
                                        "example": "Ours, after all, was not a marriage arranged by a matchmaker or by our parents."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "vender",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/37eec82193a16be7aebcc4e75068e0a696652966_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈvendə/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (BrE vendor) sb. who sells things, esp. on the street （尤指街上的）小贩",
                                        "example": "He bought a copy from a newspaper vender."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "pedal",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/18bc230e7b8065792a948871bcd45641b95c1064_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈpedl/ 【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(AmE) (~ up ∕ along ∕ down, etc.) ride a bicycle 骑（自行车）",
                                        "example": "Andrew pedaled up the road toward the town center."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "trademark",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/300506f6b4cbad6e6da67d3997289f43c9d328a7_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtreɪdˌmɑːk/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "a.】of or being a distinctive, identifying feature or characteristic 特有的；标志性的",
                                        "example": "She was about to burst into her trademark laughter when her mom silenced her."
                                    },
                                    {
                                        "explanation": "n.】[C] a special name, sign, or word that is marked on a product to show that it is made by a particular company, that cannot be used by any other company （公司某一产品的）商标",
                                        "example": "The big letter \"M\" is McDonald's best-known trademark."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "distract",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1ef293f4d873c02489785a939d8f4584c78b8498_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈstrækt/ 【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "take sb's attention away from sth. by making them look at or listen to sth. else 分散（注意力）；使分心",
                                        "example": "Try not to distract the other students."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "distracting",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/84de477c54edfeed49683780a3e9a288bc4c6fa1_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈstræktɪŋ/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "preventing you from concentrating on sth. 分散注意力的；使人分心的",
                                        "example": "I find it too distracting to work with the television on."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "high-pitched",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d41343ffd79988e6e7ba3c5e5e19ca2a4da231c1_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌhaɪ ˈpɪtʃt/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(of sounds) very high （声音）很高的；尖厉的",
                                        "example": "I could hear high-pitched laughter coming from the girls' bedroom."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dealer",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/15d66f9a02901369e32c51139b019c7e5dcd62fa_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdiːlə/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb. who buys and sells a particular product 交易商；贸易商",
                                        "example": "She bought the painting from a Swiss art dealer two months ago."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "register",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/091f22f92e3dc5b8fc8ae5cdb099fe511653aeff_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈreʤɪstə/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[n.][C] the range of musical notes that sb.'s voice or a musical instrument can reach （嗓音或乐器的）音域，声区，音区",
                                        "example": "Singers have to learn how to sing in the upper register."
                                    },
                                    {
                                        "explanation": "[v.]put sb.'s / sth.'s name on an official list 记录；登记",
                                        "example": "How many students have registered for English classes this semester?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sharpen",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8f889878116ecc9d6543548c247f870aad99c66c_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʃɑːpən/ 【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sth. have a sharper edge or point, or become sharper （使）变锋利（尖锐）",
                                        "example": "Anne sharpened her pencil and got out her homework."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sharpener",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c3e1daf67e3ef720dbbb2e4fdbed9ebac80c0160_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʃɑːp(ə)nə/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a person or device that makes sth. sharp 削磨的人；磨具；削具",
                                        "example": "You can buy the best pencil sharpeners at low prices in our store."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "clack",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3258fcbf8eaca9f139c45a889495ea3a55d77450_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/klæk/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[sing.] the short loud sound of one hard object hitting against another 硬物撞击声；咔哒声；啪嗒声",
                                        "example": "I heard the clack of high heels as she crossed the yard."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "soothe",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1b5dbe20a6b5cd2d0937591a8d89608b180ab5cb_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/suːð/ 【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. feel calmer and less anxious, upset, or angry 抚慰；安慰；使平静",
                                        "example": "Lucia soothed the baby by rocking him in her arms."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "soothing",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1e3cad63cc37a3ad9c8c808cae12cc9c1359c5d5_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsuːðɪŋ/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "making you feel calm and less nervous, worried, or upset 抚慰的；安慰的",
                                        "example": "My mother had a gentle, soothing voice."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "reminder",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/16e1e1f0754bcc409f38b1cf4e8662a7f6d22605_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈmaɪndə/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sth. that makes you notice, remember, or think about sth. 起提醒作用的事物",
                                        "example": "The town wanted to forget the war but the destroyed bridge was a painful reminder."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "bustling",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/206814f780b309ff00a28ffa259178c444beadcd_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈbʌslɪŋ/ 【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ with) full of people moving about in a busy way 繁忙的；熙熙攘攘的",
                                        "example": "The flower market was bustling with shoppers."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "psyche",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f43de2bd9bed37109a71b93f29d6eda733444d8e_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsaɪki/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, usu. sing.] sb.'s mind, or their deepest feelings, which control their attitudes and behavior 心灵；灵魂；精神",
                                        "example": "She knew, at some deep level of her psyche, that what she was doing was wrong."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "greet",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/78d72dd2e48ff32f96c8529b451f4543fcc93f07_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/griːt/ 【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "say hello to sb. or welcome them 问候；迎接；招呼",
                                        "example": "She greeted each of the guests as they came through the door."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "bubble",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/561a12f782bcab0f4cb2f494744fb028351a7d88_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈbʌbl/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a ball of air or gas in liquid （液体中的）气泡，泡沫",
                                        "example": "When water boils, bubbles rise to the surface."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "emphasize",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1472aab87ce90df8303a8d725d5d9210c8d121e9_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈemfəˌsaɪz/ 【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "give special importance to sth. 强调；重视；着重",
                                        "example": "The report emphasizes the importance of improving safety standards."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dynamism",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d67943f3c425e99fcaac4d3c3174bd1c4615ec7d_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdaɪnəˌmɪz(ə)m/ 【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] energy and enthusiasm to make new things happen or to make things succeed 精力；活力；劲头",
                                        "example": "People responded positively to Ruth's cheerfulness and dynamism."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "repeatedly",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/97f298cf1b31d195e38f8bbfb2faf98fff46c8c1_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈpiːtɪdli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "many times 再三地；重复地",
                                        "example": "Sam was repeatedly warned not to work so hard."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "colleague",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/872f8ba275dfd59c2190219836357a26e9f25d0a_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkɒliːg/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb. you work with — used esp. by professional people 同事；同僚（尤为专业人士所用）",
                                        "example": "She discussed the idea with some of her colleagues."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "decline",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3b54b52e4ae424e8233d0f81ac0c1481b998f755_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈklaɪn/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【v. 】(fml.) refuse politely to accept or to do sth. 谢绝；婉言拒绝",
                                        "example": "The Prime Minister was asked for his opinion but he declined to comment."
                                    },
                                    {
                                        "explanation": "【vi.】decrease in quantity or importance 减少；降低",
                                        "example": "Spending on information technology has started to decline in recent years."
                                    },
                                    {
                                        "explanation": "【n. 】[U, sing.] a decrease in the quality, quantity, or importance of sth. 下降；减少；消减；衰落",
                                        "example": "There has been a decline in the size of families."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "mug",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/28a62583693a5619d72f410c2af8f570fe7682b4_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/mʌg/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a tall cup used for drinking tea, coffee, etc.（喝茶、咖啡等用的有柄的）大杯，马克杯",
                                        "example": "Jake had a quick breakfast and a mug of coffee in the morning."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "accompany",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4e6d9c30dee02bd61bb043dd9918750fac7e85b0_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈkʌmp(ə)ni/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) happen or exist at the same time as sth. else 伴随",
                                        "example": "The disease is accompanied by headache and fever."
                                    },
                                    {
                                        "explanation": "2) go somewhere with sb. 陪伴；陪同",
                                        "example": "Children under 14 must be accompanied by an adult in these activities."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "refusal",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2c5c9a7f5084fc3913b2b28628349b0e6b6a986b_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈfjuːzl/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] an act of saying or showing that you will not do, give, or accept sth. 拒绝；回绝",
                                        "example": "His refusal to discuss the matter made me angry."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "gesture",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f7f758dcdc58a469425d25111ac7d98e10c70045_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdʒestʃə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [C] sth. that you say or do, often sth. small, to show how you feel about sb. / sth. （表明态度的）表示，姿态",
                                        "example": "They sent me some flowers as a gesture of goodwill."
                                    },
                                    {
                                        "explanation": "2) [C, U] a movement of part of your body, esp. your hands or head, to show what you mean or how you feel （表达意思或感觉的）手势，姿势",
                                        "example": "Jim raised his hands in a despairing gesture."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "beverage",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/10b17b5873f797b265fc9a66c3a3fcf4d5d799fd_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈbev(ə)rɪdʒ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (fml.) a hot or cold drink 饮料",
                                        "example": "Beer is the most popular alcoholic beverage."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "preference",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d26c65a8959c6b5338253b7937b5bc6401f92534_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈpref(ə)rəns/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a greater interest in or desire for sb. / sth. than sb. / sth. else 偏爱；偏好",
                                        "example": "Many people expressed a strong preference for the original plan."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "lifelong",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8ccfe52c2ef1d8d5f22aa4481b2e93898d449e5b_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlaɪfˌlɒŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) continuing or existing all through your life 终身的；毕生的",
                                        "example": "She first visited Ireland when she was 10, and developed a lifelong interest in the country."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "bitter",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/62579909018c652d73b51ceb71a7a543b948ce35_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈbɪtə/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (of arguments, disagreements, etc.) very serious and unpleasant, with a lot of anger and hatred involved （争论、分歧等）激烈而不愉快的，充满愤怒与仇恨的",
                                        "example": "The couple had a bitter quarrel over the division of labor."
                                    },
                                    {
                                        "explanation": "2) feeling angry, jealous, and upset because you think you have been treated unfairly 愤愤不平的；充满怨恨的",
                                        "example": "I feel bitter about his behavior."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "in-laws",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/eeb93eb906ed1733a8e4f1aedc8765d07a953dfa_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɪnlɔːz/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[pl.] (infml.) your relatives by marriage, esp. the father and mother of your husband or wife 姻亲（尤指公婆或岳父母）",
                                        "example": "We lived with my in-laws until we had enough money to buy a house of our own."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "hospitable",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/920f0b621116e8e4a76e92fedff6e04dadb0bf26_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈhɒˈspɪtəbl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "friendly, welcoming, and generous to visitors 好客的；殷勤的；热情友好的",
                                        "example": "The local people were very kind and hospitable."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dutiful",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fe5e36df6fff799e8918ca1dec640944e0f05602_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdjuːtɪfl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "doing what you are expected to do and behaving in a loyal and obedient way 尽责的；忠诚的；顺从的；恭敬的",
                                        "example": "His dutiful secretary was always there to answer her boss' call when he needed her."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stew",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e6aed8fb5db4d908a6d17d959af5de3b3d6bc8c9_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/stjuː/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【v.】cook sth. slowly, or allow sth. to cook slowly, in liquid in a closed dish 炖；煨",
                                        "example": "The meat needs to stew for two hours."
                                    },
                                    {
                                        "explanation": "【n.】[C, U] a dish of meat and vegetables cooked slowly in liquid in a container that has a lid 炖的菜；煨的菜（有肉和蔬菜）",
                                        "example": "I'm making a stew for lunch."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "triumphantly",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5d30327fb135a999b620a01f595068a7a2d64b61_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/traɪˈʌmfəntli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "in a state of showing pleasure and pride because of a victory or success （因胜利或成功而）洋洋得意地，耀武扬威地",
                                        "example": "\"I've got a job,\" she announced triumphantly."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "glance",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d0617a4c8f6be4b000188df9c30b0535d2ec5a76_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/glɑːns/【vi.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ at / up / down, etc.) quickly look at sb. / sth. 一瞥；看一眼",
                                        "example": "The man glanced nervously at his watch."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "milky",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/674b123455182ccdb2e8d585d593a69d167616b5_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmɪlki/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "containing a lot of milk 掺奶的；多乳的",
                                        "example": "Water, fruit juice, and hot milky drinks are offered on planes."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dagger",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7dc75f9d266d8a6233701113cd02c8a5fab84b01_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈdægə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a short pointed knife used as a weapon 匕首；短剑"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "basically",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4a787172d89651f927aad6563bbcd8a7447c1360_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈbeɪsɪkli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used when you are giving your opinion or stating what is important about a situation 总的来说；从根本上",
                                        "example": "Basically, we're looking for someone who can work three afternoons a week."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "outsider",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e00f69e72409dcce4204a6b3a997ade06426aa0e_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/aʊtˈsaɪdə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a person who is not accepted as a member of a society, group, etc. 外人；局外人",
                                        "example": "I'm an outsider, the only foreign woman in the group."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unite",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/678bbb3cc749e1cada26b99b17fbba458b03031d_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/juːˈnaɪt/【v.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if different people or organizations unite, or if sth. unites them, they join together in order to achieve sth. （使）联合；（使）团结",
                                        "example": "We will unite in fighting crime."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "united",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0f55ab864c01e34d022a7bb96831a3f6002ac645_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/juːˈnaɪtɪd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(of people or groups) in agreement and working together （人或群体）和谐的，一致的，团结的",
                                        "example": "We need to become a more united team."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sacred",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d98e6c2a78a4c00e9d23b388000feaf103329f6a_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈseɪkrɪd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) very important or greatly respected 很重要的；神圣的；深受尊重的",
                                        "example": "Few things were sacred to Henry, but local history was one of them."
                                    },
                                    {
                                        "explanation": "2) relating to a god or religion 上帝的；神的；宗教（性）的",
                                        "example": "Certain animals were considered sacred."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "workplace",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/093e20f18f817897209f48fda762fbe2dc5715a9_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈwɜːkˌpleɪs/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] the room, building, etc. where you work 工作场所",
                                        "example": "How do you keep your personal problems out of the workplace?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "pop",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/16ab8fc66077e90e14e739008f81b0aa85feba14_96k.mp3#duration=0.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/pɒp/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【vt.】(infml.) quickly put sth. somewhere, usu. for a short time 迅速地放置",
                                        "example": "She took out a piece of chewing gum (口香糖)and popped it in her mouth."
                                    },
                                    {
                                        "explanation": "【vi.】come suddenly or unexpectedly out of or away from sth. （突然或出人意料地）蹦出，离开，脱落",
                                        "example": "The top button popped off my shirt."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unpleasant",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ae9ad3e11b5e6f5bedc7b5af6edfecc808d675a7_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ʌnˈpleznt/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "not pleasant or enjoyable 使人不愉快的；不合意的；讨厌的",
                                        "example": "Undercooked potatoes taste unpleasant and can be harmful."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "brew",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/07290b23fe17692e62e4af40aeac8e57c609f6b0_96k.mp3#duration=0.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/bruː/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C](esp. BrE) an amount of tea made at one time （茶）一次的冲泡量",
                                        "example": "Nothing beats the taste of a fresh brew made from Carlisle Tea's fine quality loose-leaf teas."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "tedious",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/28e787f9538ff6d278cf80ef8227e01ea95286a8_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtiːdiəs/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "lasting or taking too long and not interesting 冗长的；啰唆的；单调乏味的；令人厌烦的",
                                        "example": "We had to listen to the tedious details of his presentation."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "entry",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4c9574788ff8f430680f7f358d8f20d4186c9aa4_96k.mp3#duration=0.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈentri/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [U] the act of recording information in a computer, book, etc. 登记；输入；录入",
                                        "example": "The program is used to describe the entry of data into the network."
                                    },
                                    {
                                        "explanation": "2) [C, U] the act of going into sth. 进入",
                                        "example": "It was dark and their entry into the camp had gone unnoticed."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "ingrained",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/026965e2eea01eec02f0478c6c8df14f228a9d6f_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɪnˈgreɪnd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ in) (of a habit, attitude, etc.) that has existed for a long time and is therefore difficult to change （习惯、态度等）根深蒂固的，日久难改的",
                                        "example": "The idea of doing our duty is deeply ingrained in most people."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "trolley",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b78919a04aac9151cb10fcb6e51d48297c65bd42_96k.mp3#duration=0.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtrɒli/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (AmE cart) a small table on very small wheels, used for carrying or serving food or drink （运或送食物、饮料的）手推车，台车"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "consume",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/294e0ac59cdee7ebec3d9d303a6efb6592a0bd4a_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈsjuːm/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (fml.) eat or drink sth. 吃；喝",
                                        "example": "In order to survive, human beings need to consume food and water."
                                    },
                                    {
                                        "explanation": "2) use time, energy, goods, etc. 消耗；消费",
                                        "example": "A smaller car will consume less fuel."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "poll",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0886a290fbdd0be493b752027f9ffe75ef755c66_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/pəʊl/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "ask a lot of people the same questions in order to find out what they think about a subject 对···进行民意测验（调查）",
                                        "example": "Over 50% of those polled were against the proposed military action."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Phrases and expressions",
                "children": [
                    {
                        "word": "more or less",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2d9972141af99f0d61bc08da311bec17baf42331_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "almost 几乎",
                                        "example": "This report says more or less the same thing as the previous one."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "bundle up",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/76071af3cdf6b66647d653130ce3ac402264d594_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "put warm clothes on sb. or yourself because it is cold （因寒冷）给···穿上暖和的衣服",
                                        "example": "You'll have to bundle up; it's cold outside."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "make one's way (to / toward sth.)",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fe0ba9aa4fda9ff4e79e0e0822ae2249f39bfbb9_96k.mp3#duration=5.7&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "move or get somewhere 去；前往；到···地方去",
                                        "example": "The team slowly made their way back to the base camp."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "pass on",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c69586f4e8b8cd31036b36c3a724fe8d17e070a1_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "give sth. to sb. else, esp. after receiving it or using it yourself 转交；（用后）递给，传给",
                                        "example": "She said she'd pass the message on to the other students."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "track down",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/060059c2b82b1708e1280645d027d082fb3bd08b_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "find sb. / sth. that is difficult to find by searching or looking for information in several different places 追踪到；追查到",
                                        "example": "The police have so far failed to track down the attacker."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "have sb. / sth. in mind",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/12b324de2446c4a04ddecaf2ab16bd01d3ac3791_96k.mp3#duration=5.1&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "have an idea about who or what you want for a particular purpose 心里已有某人 / 某事物（作为···的目标选项）",
                                        "example": "Have you got any particular color in mind for the bedroom?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "hang around with",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9628be78766449a54132894eff9a371ead8abec4_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "spend a lot of time with sb. 与···长时间待在一起",
                                        "example": "The people I used to hang around with were much older than me."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "bring ······ to life",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/266cd0f758c3483cc841526473e2970ff67114ea_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. / sth. lively or interesting （使）变得生动；（使）变得有趣",
                                        "example": "With these pictures I hope to bring the room to life."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "drive sb. crazy / nuts / mad / insane",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/29f53204dbb73a70ebb9ff1ef26df76aea73697e_96k.mp3#duration=9.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. feel very annoyed 把某人逼疯",
                                        "example": "Would you stop that humming? You're driving me crazy!"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "hit / strike home",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b367498e65b9f8d26430ce6888c38c0f0e0994aa_96k.mp3#duration=2.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(of a remark, etc.) have a strong effect on sb., in a way that makes them realize what the true facts of a situation are （言语等）使人豁然醒悟",
                                        "example": "She saw the emotion in her father's face and knew her words had hit home."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "take it upon / on oneself (to do sth.)",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d1149a1851a1b6780db1f16a673c75348c027689_96k.mp3#duration=7.3&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(fml.) decide to do sth. without getting sb.'s permission or approval first 擅自做主做某事；自作主张做某事",
                                        "example": "He took it upon himself to personally thank each person at the meeting."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "carry over",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/654badc3cc4c43250a3fc3e9c97dfc757ab00510_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "continue to exist in a different situation （在不同情况下）继续存在，保持下去",
                                        "example": "Attitudes learned at home carry over into the playground."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "pop on",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/deba18f4438232806923e49d2d5c35c85a99ba6a_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(BrE, spoken) quickly turn on a piece of electrical equipment 迅速开启（电器）",
                                        "example": "Pop on the stove with a loose fitting lid to allow steam to escape."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Proper names",
                "children": [
                    {
                        "word": "Forbidden City",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c19431586bd6e37e57296bc2582bff1d61c5a362_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/fəˈbɪdn/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "紫禁城（中国明清两代的皇家宫殿）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Buckingham Palace",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/103f9c2299be9185f8d6af731b218b81b63c4380_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈbʌkɪŋəm/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "白金汉宫（英国王室官邸，位于伦敦）"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]

book1[5] = [
            {
                "name": "New words",
                "children": [
                    {
                        "word": "foolish",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/31d4df2074e66ac12783a924a250418fdcf836c3_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfuːlɪʃ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "unwise, without good sense 愚蠢的；笨的",
                                        "example": "It would be foolish to spend money on something you can't afford."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "intersection",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1259bcee5cf31b325b7132c91bd953d129c4a513_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɪntəˌsekʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a place where roads, lines, etc. cross each other, esp. where two roads meet（尤指两条道路的）交叉点，十字路口；（线的）交叉点",
                                        "example": "Traffic lights have been placed at all major intersections."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "encounter",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/086b75121d699b0a95715cd8d24217abe94b2145_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈkaʊntə/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (fml.) meet sb. without planning to 偶然碰到（某人）",
                                        "example": "I first encountered him when I was studying at Cambridge."
                                    },
                                    {
                                        "explanation": "2) experience sth., esp. problems or opposition 遇到，遭遇（尤指问题或反对）",
                                        "example": "The more dangers we encounter, the harder should we push forward."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "peer",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5c37f6ff8cf9f715df7b221890b3821c4e8af6f5_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/pɪə/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【vi.】look very carefully or hard at sth., esp. because you are having difficulty seeing it（尤指因看起来费劲而）凝视，盯着看",
                                        "example": "I had been peering at a computer printout that made no sense at all."
                                    },
                                    {
                                        "explanation": "【n.】[C, usu. pl.] (fml.) sb. of the same age, social class, etc. 同龄人；身份（或地位）相同的人",
                                        "example": "Children compete to win the approval of their peers."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "upward",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2a19a8cc1d5a386f531a9f4469ec645f999cf773_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʌpwəd/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(esp. AmE) moving or pointing toward a higher position 向上；朝上",
                                        "example": "Pointing upward, he indicated a large nest high in the tree."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "cloakroom",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7fad985a63718fb80c25975dc2789e154146a391_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkləʊkˌruːm/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a small room where you can leave your coat 衣帽间；衣帽寄存处"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "herd",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/16641b802c4db9d7003fd20b70cf85af57729cd8_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/hɜːd/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a group of animals of one kind that live and feed together 兽群；牧群",
                                        "example": "The milkman selected the spotted cows, from among a herd of 200."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "instinct",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6a91c3f9476bde23c87e02b429d5a244ebe4ca1a_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɪnstɪŋkt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a natural tendency to behave in a particular way or a natural ability to know sth., which is not learned 本能；直觉；天性",
                                        "example": "Hearing the loud noise, Mary's first instinct was to hide under the blankets."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "herd instinct",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8a952e0eb749007f5baca8b2d7dce0dcc45b4ee9_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[sing.] the natural tendency in people or animals to behave or think like other people or animals 群体本能（人或动物在行为或思维上从众的自然趋势）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dictate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/775ac2f22fce35a9f9e49c4a05b811f840c231f6_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪkˈteɪt/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【vt.】control or influence sth. 支配；影响；决定",
                                        "example": "Circumstances dictated that they played a defensive rather than attacking game."
                                    },
                                    {
                                        "explanation": "【v.】say words for sb. else to write down 口授；让（某人）听写",
                                        "example": "She's dictating a letter to her secretary right now."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "evil",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/27b9b4bd1980282133ad6bcd17f99fd8382df349_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈiːvl/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] a force that causes bad things to happen 罪恶；邪恶",
                                        "example": "There's always a conflict between good and evil in his plays."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stock",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/74ca8d09f9feb084cac17b32273120bc4ce33d7f_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/stɒk/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [C] (esp. AmE) a share in a company 股份；股票"
                                    },
                                    {
                                        "explanation": "2) [C, U] a supply of a particular type of thing that a shop has available to sell 存货；现货",
                                        "example": "We have a huge stock of quality carpets on sale."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stock market",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/77f06a201553146743955bf84e4a74677d39a791_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, usu, sing.] the business of buying and selling shares in companies and the place where this happens 证券交易（所）；股票交易（所）；股市"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "panic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fd7ea95b7543e5aa41e5ecd70b4b9c1064d70048_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈpænɪk/【n.[C, usu. sing.]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) a situation in which people are suddenly made very anxious, and make quick decisions without thinking carefully 人心惶惶的局面；惶恐不安",
                                        "example": "The magazine article is about the recent panic over the safety of baby milk."
                                    },
                                    {
                                        "explanation": "2) an overwhelming feeling of fear and anxiety 恐慌；惊恐",
                                        "example": "The audience were thrown into a panic when the fire started."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "religion",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b5f82c19c8486f7227d70a744628b012b3420c36_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈlɪdʒ(ə)n/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the belief in the existence of a god or gods, and the activities that are connected with the worship of them 宗教；宗教信仰",
                                        "example": "Try to avoid as much as possible subjects such as religion, sex, or politics."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "paralyze",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/896c378312de322974cd9e8b0ec6e67c9e067b95_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈpærəˌlaɪz/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) make sth. unable to operate normally 使无法正常运转",
                                        "example": "The regional capital was paralyzed by a general strike."
                                    },
                                    {
                                        "explanation": "2) make sb. lose the ability to move part or all of their body, or to feel it 使瘫痪；使麻痹",
                                        "example": "Her legs were partly paralyzed in the crash."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "legendary",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/419e273e292842e9d9971f4bd7080dfcb43bf6ed_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈledʒ(ə)nd(ə)ri/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "very famous and admired 非常有名的；大名鼎鼎的；传奇式的",
                                        "example": "He is legendary for his fearlessness and determination."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "psychologist",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d5abd1b7b4b20fb502c1cd5027b761c9463f7cfd_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/saɪˈkɒləʤɪst/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a scientist trained in psychology 心理学家",
                                        "example": "Psychologist Martin Lloyd-Elliott is also a best-selling author."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "warp",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e8e5ba7abc0654041d2a83eba5febdf4cb439f43_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/wɔːp/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【vt.】influence sb. so that they begin to behave in an unacceptable or shocking way 使（行为等）不合情理",
                                        "example": "I never had any toys since my father thought that they would warp my personal values."
                                    },
                                    {
                                        "explanation": "【v.】become, or make sth. become, twisted or bent out of its natural shape, for example because it has become too hot, too damp, etc.（使）扭曲，弯曲，变形",
                                        "example": "The window frame must have been warped; it won't close properly."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "correspond",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ea677f666bce729f71b910e2a6442fde865b7971_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌkɒrɪˈspɒnd/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ to / with) be the same as or match sth. 相一致；符合",
                                        "example": "Your account of the event does not correspond with hers."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "survival",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f171a1fb9f48c54bec4ecbd7240064b8fa52ba3c_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/səˈvaɪvl/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the state of continuing to live or exist 生存；幸存",
                                        "example": "The man's survival was surprising, as the doctors thought he would die."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "hunter-gatherer",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/34a133626800acafadbe0dde5b88f220a77ea53b_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌhʌntə ˈgæðərə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a member of a group of people that lives by hunting and looking for plants that can be eaten, rather than by keeping animals for food or by growing crops 采猎者（以打猎和采集植物为生的人）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "bolt",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/31602d9ed627a361e59dc535ab763926883e9111_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/bəʊlt/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "suddenly run somewhere very quickly, esp. in order to escape or because you are frightened 逃跑；跑开",
                                        "example": "The thief bolted when he saw the policeman."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "scratch",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/22ee46bdeeb046d65d98d67fc4f690af6aa3207e_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/skrætʃ/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "rub your fingernails against your skin 抓；搔",
                                        "example": "Jessica lifted her sunglasses and scratched her nose."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sprint",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/52a6b6841f2030bb688154f8bdd233f8ae4ed440_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/sprɪnt/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "run very fast for a short distance（短距离）快速奔跑，冲刺",
                                        "example": "I saw Charlie sprinting through the traffic toward me."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "gene",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/003ce5369dbb67be78aa0e981c95b88efe500ec5_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dʒiːn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a part of a cell in a living thing which controls its physical characteristics, growth, and development 基因",
                                        "example": "He said he was good at sports because he had the athletic gene."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "descendant",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e18dc24dd04311b9e6ac53535a5dea65e4654aaf_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈsendənt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb. who is related to a person who lived a long time ago, or to a family, group of people, etc. that existed in the past 后代；后裔",
                                        "example": "They are descendants of the original English and Scottish settlers."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "rooted",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cbed0eb1312bc2230bf641e51128e1ef1bf01d7c_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈruːtɪd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "firmly fixed and unchangeable（观念、原则等）根深蒂固的",
                                        "example": "The report suggests that deeply rooted cultural and social factors play a role in these behaviors."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "impressive",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f27c48c91c63010cb2e0407351126b04d57e3b19_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪmˈpresɪv/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(of things or people) making a strong impression, because they are very large, good, skillful, etc. 给人印象深刻的",
                                        "example": "The building looked as impressive in reality as it did in photographs."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Nazi",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f57d179b80c98f74f9d3ee10f1f325d9f87c159a_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈnɑːtsi/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "belonging to or connected with the National Socialist German Workers' Party which controlled Germany from 1933 to 1945 纳粹党的"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "propaganda",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/975daed7f9a26e3d529a470077bd680d070fb64f_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌprɒpəˈgændə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] information which is false or which emphasizes just one part of a situation, used by a government or political group to make people agree with them（政府或政党为了影响民意而进行的）宣传",
                                        "example": "These reports clearly contain elements of propaganda."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "radical",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/17d88512187784854effdea1ee9b55ff0e019a05_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈrædɪkl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "thorough and complete 彻底的；完全的",
                                        "example": "The Football League has announced its proposals for a radical reform of the way football is run in England."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "roar",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/04f02ed1e8bd237ea7e1cece75bac956fda2e45a_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɔː/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【v. 】shout sth. in a deep powerful voice 咆哮；大声喊叫",
                                        "example": "It was such a great performance that the audience roared with appreciation."
                                    },
                                    {
                                        "explanation": "【vi.】make a deep, very loud noise 吼叫；呼啸",
                                        "example": "We were so afraid as we heard a lion roar."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "anonymously",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/03803cb276bbdfe2933ea7ea71256f0e7b15bde3_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈnɒnɪməsli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "namelessly; without giving a name 以匿名的方式；不透露姓名地",
                                        "example": "The latest photographs were sent anonymously to the magazine's Paris headquarters."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "consent",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c0837436f3df1c0de6069442bd6dcecd8bcfdf90_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈsent/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ to) give your permission for sth., or agree to do sth. 同意；允许",
                                        "example": "She asked her mother whether she would consent to a small celebration after her graduation."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "advertising",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d3fd47b834b6b4f535ec45bcd1799a0daecd7b89_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈædvəˌtaɪzɪŋ/【n. 】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the activity or business of drawing public attention to goods and services on television, in newspapers, etc. 广告活动；广告业",
                                        "example": "The advertising campaign is aimed primarily at young people."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "disadvantage",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/89c5e8d4bfe10356151d97f1b627310bfe8388be_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌdɪsədˈvɑːntɪdʒ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] sth. that causes problems and tends to stop sb. / sth. from succeeding or making progress 不利因素；缺点",
                                        "example": "You have to balance the advantages of living downtown against the disadvantages."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "skeptical",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f5821d52dc6ac3da2d0c366d1d3f665e669a59d0_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈskeptɪkl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(BrE sceptical) having doubts that a claim or statement is true or that sth. will happen 怀疑的；心存疑惑的",
                                        "example": "They are skeptical about my chances of winning."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "novelist",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7432f68791ab5b87e6770cf431ef0fd4cd1b674e_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈnɒvəlɪst/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a person who writes novels 小说家",
                                        "example": "Mark Twain has been regarded as the greatest American novelist of his generation."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "transit",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5a1e4ad98dba00ab1957f9b47c176f6408830217_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtrænzɪt/【n.】[U]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (BrE transport) a system for moving people from place to place 交通运输系统",
                                        "example": "The president wants to improve the nation's highway and mass transit system."
                                    },
                                    {
                                        "explanation": "2) the process of moving goods or people from one place to another （货物或人的）运输",
                                        "example": "They promised that my baggage would not be damaged in transit."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "convert",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈvɜːt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "change sth. into a different form, or change sth. so that it can be used for a different purpose or in a different way 使转变；使转化；使改造",
                                        "example": "This device can be used to convert a signal into a digital code."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ba0eb46aa5659b02165e0a095e607680565aae0a_96k.mp3#duration=1.7&t=.mp3"
                    },
                    {
                        "word": "prototype",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈprəʊtəˌtaɪp/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] the first design of sth. from which other forms are copied or developed 原型；雏形；最初形态",
                                        "example": "We plan to release a prototype this autumn for trial in hospitals."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c42d5e8e8839cae5226c5148e6340b7a27e18962_96k.mp3#duration=1.7&t=.mp3"
                    },
                    {
                        "word": "input",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɪnpʊt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(input, input; inputted, inputted) put information into a computer （向计算机）输入",
                                        "example": "All call center staff do is input data into computers and so it makes every sense that you do it yourself to cut cost."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/81540ade54fcef5bc32bf57ff73db6f8eaf69a08_96k.mp3#duration=1.4&t=.mp3"
                    },
                    {
                        "word": "smartphone",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsmɑːtˌfəʊn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 智能手机"
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4c8c19ff2173a4369bf1ab30fd82678e64aa3543_96k.mp3#duration=1.6&t=.mp3"
                    },
                    {
                        "word": "existing",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪgˈzɪstɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) found or used now 目前的；现存的",
                                        "example": "Under existing regulations, you are not allowed to bring animals into the country."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/04cba1f9bece0961d613f9865b73d96ff7a3718c_96k.mp3#duration=1.3&t=.mp3"
                    },
                    {
                        "word": "web-based",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈweb ˌbeɪst/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "relating to or done using the Web (the system of connected documents on the Internet) 基于网络的",
                                        "example": "With the new web-based software, creating a purchase order should take just a few minutes."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c7796d5bf98f0ab8cc89630cf4cb4f5969f62dec_96k.mp3#duration=1.6&t=.mp3"
                    },
                    {
                        "word": "code",
                        "pee": [
                            {
                                "partOfSpeech": "/kəʊd/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a system of words, letters, numbers, or symbols that represent a message or record information secretly or in a shorter form 密码；暗码；电码；代码",
                                        "example": "He received a message written in code yesterday and he didn't know what to do about it."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/674389b90dee82b25a5e4b9d3198ad7f368e37a6_96k.mp3#duration=1.3&t=.mp3"
                    },
                    {
                        "word": "metropolitan",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌmetrəˈpɒlɪt(ə)n/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) connected with a large or capital city 大城市的；大都会的",
                                        "example": "This is an issue that should be decided by local and metropolitan governments."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7fe145a66bb9cd681283db7e99ad04a052a77244_96k.mp3#duration=1.6&t=.mp3"
                    },
                    {
                        "word": "real-time",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈrɪəl ˌtaɪm/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) of or being the very rapid use, handling, or showing of information by a computer 即时处理的；实时的",
                                        "example": "We are designing a secure and real-time voice transmission system."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d8d59f562050f8eb27f6da1dd04d6757f064b015_96k.mp3#duration=1.6&t=.mp3"
                    },
                    {
                        "word": "avenue",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈævəˌnjuː/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] used in the names of streets in a town or city 街；大街",
                                        "example": "When we visited New York, we stayed in a hotel on Fifth Avenue."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/17588c08f6cef650da7a762286a710b8604b9d37_96k.mp3#duration=1.4&t=.mp3"
                    },
                    {
                        "word": "effective",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈfektɪv/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "successful, and working in the way that was intended 有效的；产生预期效果的",
                                        "example": "The cheaper drugs are just as effective in treating this disease."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e841f36c552d319152fea05eff1a09bce7b1eadd_96k.mp3#duration=1.4&t=.mp3"
                    },
                    {
                        "word": "underestimate",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌʌndərˈestɪˌmeɪt/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "think or guess that sth. is smaller, cheaper, easier, etc. than it really is 低估；（对···）估计不足；看轻",
                                        "example": "None of us should ever underestimate the degree of difficulty women face in career advancement."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9c75e3b6e9561a6be18381597b1cace9723de39b_96k.mp3#duration=1.9&t=.mp3"
                    },
                    {
                        "word": "epiphany",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈpɪfəni/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a moment when you suddenly realize or understand sth. important 顿悟的时刻",
                                        "example": "People are all familiar with the story of Issac Newton's epiphany about gravity (地球引力) and a falling apple."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a94a259dd676bd664445fd928284b43832e861b3_96k.mp3#duration=1.3&t=.mp3"
                    },
                    {
                        "word": "aging",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈeɪdʒɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) becoming old; rather old 变老的；陈旧的",
                                        "example": "We need to replace some of the aging office equipment."
                                    }
                                ]
                            }
                        ],
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d33f8070584ae6c959bc21f2d0fa7d4c54d7ab13_96k.mp3#duration=1.1&t=.mp3"
                    },
                    {
                        "word": "shelter",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/79facaa883ad2937fdba97f82343954c43bca109_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʃeltə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [C] a building or an area with a roof over it that protects you from the weather or from danger 躲避风雨的地方；避难处",
                                        "example": "They built a rough shelter from old pieces of wood."
                                    },
                                    {
                                        "explanation": "2) [U] a place to live, considered as one of the basic needs of life 栖身之地；住处",
                                        "example": "They were in need of food and shelter after the earthquake."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "bus shelter",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/abdffc36a7c38cd2c0a4fbc860915d2743964348_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (BrE) a small structure with a roof where you wait for a bus 公共汽车候车亭"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "solar-powered",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f73548a7721cf1cfee6241d6e5fbe09f6668def6_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌsəʊlə ˈpaʊəd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "powered by energy from sunlight 太阳能驱动的",
                                        "example": "The company is developing a fully solar-powered car."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "civic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c4bb8db2c54e09b8b94a2044b03368d5d539f43c_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsɪvɪk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) relating to a town or city 城镇的；城市的",
                                        "example": "The president's visit was the most important civic event of the year."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "temper",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a770e25dc9c84d24319570c7582ef11d93b98baa_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtempə/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(fml.) make sth. less severe or extreme 使缓和；使温和；冲淡",
                                        "example": "The heat in this coastal town is tempered by the cool sea breeze (微风)."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "install",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/25d35d1c5fe5ad80ac310df84a0dd859158e36e2_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈstɔːl/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "put a piece of equipment somewhere and connect it so that it is ready to be used 安装，设置（设备）",
                                        "example": "It would cost about £3,000 to install a new heating system in a flat such as theirs."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "commute",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5213cd4991c3a05fc2d165958f45d5a3c1b2ad83_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kəˈmju:t/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, usu. sing.] the journey to work every day 上下班路程",
                                        "example": "I want to rent an apartment near my office because my daily commute takes too long."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "mayor",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/70e8ae32c7db1e1d1c5e36698016c0c465bf0737_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/meə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] the head of the government of a town or city, etc., elected by the public （民选的）市长，镇长",
                                        "example": "The crowd gathered in the town square to hear the mayor speak."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "uncertain",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3ca98654db07e37c511bc375a3e789890d4d12f1_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ʌnˈsɜːtn/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(not before noun) feeling doubt about sth. 不确定的；没把握的；拿不准的",
                                        "example": "It's still uncertain whether the College Spring Sports will be held this year."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "upbeat",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f081648fc9520f948829be786bf7164e628144a1_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʌpbiːt/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "positive and making you feel that good things will happen 乐观的；积极向上的",
                                        "example": "New research shows that all it may take to avoid this common disease is a positive and upbeat attitude."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "en route",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d649b12f496cd3d07cc098934cf7a35f1a93b07a_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɒnˈruːt/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "on the way 在路上；在途中",
                                        "example": "We stopped for a picnic en route."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "crane",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8a0a88ba42a7d1b39e85cef7f8039f5c51f471b1_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kreɪn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 吊车；起重机"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "deed",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/373bc08399afec2853371fc8768fa64531d00912_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/diːd/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (fml.) sth. sb. does, esp. sth. that is very good or very bad（尤指很好或很坏的）行为，行动",
                                        "example": "His heroic deeds were celebrated in every corner of the city."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "spark",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e3e133eea9b86cb9739cf3a7f88d6c754aef75e4_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/spɑːk/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "cause sth. to start or develop, esp. suddenly 引发；触发",
                                        "example": "Will the rapid rise in oil prices spark another crisis?"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Phrases and expressions",
                "children": [
                    {
                        "word": "join in",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b898457cabefbe66acf1f8d5e69d857efef3962a_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "take part in an activity with other people 加入，参加（活动）",
                                        "example": "Now and again he'd join in when we were playing video games."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "in other words",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/807231ba1d6f33fdfba8c5496b9dca45270d60fd_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used to introduce an explanation of sth. 换言之；换句话说；也就是说",
                                        "example": "In other words, we have to build different ways of working."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "one after another",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f45c809fcb684dfcf768ae2b53ab7c597e5126f1_96k.mp3#duration=2.0&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used to talk about a series of similar things or events that are done or happening with very little time between them 一个接一个",
                                        "example": "One after another, people described how hard it was for them to get medical care."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stay put",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3cc507b289cbde3805e5c08efef2168a4daa769d_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "stay in the original place 留在原地",
                                        "example": "Nigel says for the moment he is very happy to stay put in London."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "weigh up",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f110c2c31f43ab59dc639d324d7430ecce47d229_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "consider sth. carefully so that you can make a decision about it 权衡；仔细考虑",
                                        "example": "You have to weigh up in your mind whether to pursue your goal or not."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "later on",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1523add28dd1204453e9e07eee92c6efa348270c_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "at a time in the future 过后；后来",
                                        "example": "I hate to rush you but I have another appointment later on."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "go from bad to worse",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b63c20da5397936ddcbcb633d302a871c26d8555_96k.mp3#duration=2.7&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "become even more unpleasant, difficult, etc. 每况愈下；越来越糟",
                                        "example": "For the past couple of years my health has gone from bad to worse."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "make a, no, some, etc. difference",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1ae4171572176228448f8cb8bc51851d49f025fc_96k.mp3#duration=7.1&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "have an effect / no effect on sb. / sth. 有（或没有、有些等）作用，关系，影响",
                                        "example": "The new central heating has made an enormous difference to the house."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "up and running",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/36838a2e91c3522312603ce66f7f92f303f1fdba_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "operating normally 正常运转",
                                        "example": "We're trying to get the medical facilities up and running again."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "call in",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3dca565ee36ed87b7fd46f60a76a7175b5bc7d22_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "telephone a radio or television program with a comment or question 打电话到（电台、电视台）",
                                        "example": "It's a hot topic, and people have been calling in all morning."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "check out",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/161599c5ecfefb221ed5cba1fe79d838b70ffc74_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sure that sth. is actually true, correct, or acceptable 核实；查证；调查",
                                        "example": "Maybe we ought to go down to the library and check it out."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "tear down",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e6694c7fcac8c1ac19ea440dcda3ff7282333537_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "pull or knock down a building, wall, etc. 拆毁，拆除（建筑物、墙等）",
                                        "example": "The city government has decided to tear down several buildings and create a park."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sb. can't help (doing) sth.",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8a724e921140c722e868a78be9ebb6df4599c648_96k.mp3#duration=6.7&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(also 'sb. can't help but do sth.') used to say that sb. is unable to change their behavior, or feelings, or to prevent themselves from doing sth. 某人忍不住做某事；某人不能停止做某事",
                                        "example": "In fact, I can't help wondering what someone with your experience is doing in a place like this."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "write off",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/304878c9c424826e74aee6efa0e4a175357077d3_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "decide that sb. / sth. is useless, unimportant, or a failure 认定某人/某事无用（不重要，失败）",
                                        "example": "It's too soon to write off the project as a failure."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "pull over",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8938c7ae6d3ae3cb2a500e7077e5d7018002afaf_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "drive to the side of the road and stop your car, bike, etc. or make sb. else do this （使）车辆停靠在路边",
                                        "example": "The police signaled to him to pull over and gave him a drunk driving test."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Proper names",
                "children": [
                    {
                        "word": "Solomon Asch",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1bc8f22a4cbc4c33ebe7bc25a69e1c1ed725aa43_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌsɒləmən ˈæʃ/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "所罗门 &bull; 阿希（美国社会心理学家）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Serengeti",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c89079d1bbdf16b975fd8b687b385c3d77c74e36_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌserənˈgeti/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "（非洲）塞伦盖蒂（联合国教科文组织‘人与生物圈计划’的生物圈保护区）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Joseph Goebbels",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/155cf518a934ca3f6d77c3a1c31e29fdccd22e98_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌdʒəʊzɪf ˈgɜːbəlz/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "约瑟夫 &bull; 戈培尔（纳粹德国宣传部长）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "W. Somerset Maugham",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ae0d6d0a236d9a791d90387df598be0ae5c5aacb_96k.mp3#duration=2.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌsʌməset ˈmɔːm/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "W. 萨默塞特 &bull; 毛姆（英国著名小说家）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "John Keefe",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ceaaf0a0315b5caf6e16e9fc33b7336fae0a7b42_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "约翰 · 基夫（人名）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Manhattan",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6a18b7c825c36a40dfb68a9deb04180f71d26930_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/mænˈhætn/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "曼哈顿（美国纽约市一个行政区，纽约市的商业和文化中心）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Twilio",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/525ebec6de85e828c7c78c7298143f80c06ca772_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtwɪliːəʊ/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "美国加利福尼亚州的一家科技公司"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Menlo Park",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c90dff079c62dca99e73c85fcbd56dae71c2096e_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmenləʊ/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "门洛帕克（美国加利福尼亚州城市）"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]

book1[6]= [
            {
                "name": "New Words",
                "children": [
                    {
                        "word": "envy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a0492f2d8f6d3c8ab64d3760abe001f2ab5ec020_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈenvi/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【n.】[U] the feeling of wanting sth. that sb. else has 羡慕；忌妒",
                                        "example": "They only say such unkind things about you out of envy."
                                    },
                                    {
                                        "explanation": "【vt.】wish that you had sb. else's possessions, abilities, etc. 羡慕；忌妒",
                                        "example": "I envy her ability to talk confidently to people she has never met before."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "delight",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cf64d855eb49dc76540e221117fc772b4b182eca_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈlaɪt/\nvt.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "give sb. great satisfaction and enjoyment 使愉快；使高兴",
                                        "example": "Her recipe will delight anyone who loves chocolate."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "delighted",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/361aa5904b844a5cff2005a953adbf7cc223d5c7_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈlaɪtɪd/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "very pleased and happy 愉快的；高兴的",
                                        "example": "Thanks for your invitation. I'd be delighted to come."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "shortlist",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b5d1f4a07b12b26b19fcaed440d28d3ce6a65131_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʃɔːtˌlɪst/\nvt.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(usu. passive) (BrE) put sb. on a short list for a job or a prize 把（某人）列入入围（决选）名单",
                                        "example": "He was shortlisted for the Nobel Prize for Literature several times."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "lurch",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3b65f53a3cb606bddecca76483e68324a3971b5f_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/lɜːtʃ/\nvi.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) if your heart or stomach lurches, it seems to move suddenly because you feel shocked, frightened, etc. （因震惊、惊恐等而）感到心猛地一跳，胃里猛地翻腾了一下",
                                        "example": "Virginia's heart lurched painfully in her chest on hearing the news."
                                    },
                                    {
                                        "explanation": "2) walk or move suddenly in an uncontrolled or unsteady way 突然不稳地行走（移动）；蹒跚而行",
                                        "example": "Suddenly the horse lurched to one side and the child fell off."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "spin",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4dc42edec0047e059e2e79af8b954a692c7e20f6_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/spɪn/\nv. (spun, spun)",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) if your head or the room is spinning you feel as if you might faint because you are shocked, excited, or drunk （因震惊、兴奋或醉酒）头晕，感到天旋地转",
                                        "example": "I was pouring with sweat, and my head was spinning."
                                    },
                                    {
                                        "explanation": "2) (cause to) turn round and round fast （使）快速旋转",
                                        "example": "He spun the wheel sharply and made a U turn in the middle of the road."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "clench",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/972460082f907ca3bc8e711c334d260fc4a13627_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/klentʃ/\nv.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if you clench a part of your body such as your hand or your mouth, or if it clenches, you close it tightly, esp. because you are angry or upset （尤指因生气或不安）握紧，绷紧，咬紧",
                                        "example": "Through clenched teeth she told him to leave."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "tighten",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c8fdd5530fa09f5a3dbf692d91d94d6deaa9ef6c_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtaɪtn/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【v.】become stiff or make a part of your body become stiff （使）（身体的某一部分）变得僵硬，变得僵直",
                                        "example": "Sofia's throat had tightened and she couldn't speak."
                                    },
                                    {
                                        "explanation": "【vt.】close or fasten sth. firmly by turning it 使变紧；拧紧",
                                        "example": "I'd put the new tyre on and tightened up the wheel."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "scroll",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5c8f40026810f5c73fc814377d4ffb18dbb522ba_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/skrəʊl/\nvi.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "move information on a computer screen up or down so that you can read it （将计算机屏幕上的信息）上下滚动，滚屏（以便阅读）",
                                        "example": "Scroll to the end of the document and you will find what you need."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "vaguely",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a0cf417d5f2cdb5dea8141a485714b89167b1ea2_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈveɪgli/\nad.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "slightly 略微；稍微",
                                        "example": "He was vaguely aware of footsteps behind him."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fortune",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b9945c9740f05d38b030f3f9f2d0e86f8211e151_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfɔːtʃən/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [U] chance or luck, and the effect that it has on your life 运气；机遇",
                                        "example": "I had the good fortune to work with a brilliant head of department."
                                    },
                                    {
                                        "explanation": "2) [C] a very large amount of money 大笔的钱；巨款",
                                        "example": "He made his fortune in car sales."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stir",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/93e064e266dfd4161cbd005fb2a60de289d92232_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/stɜː/\nvt.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) make sb. have a strong feeling or reaction 激发，激起（强烈的感情）；引起（强烈的反应）",
                                        "example": "Looking at the photographs stirred childhood memories of the long hot summers."
                                    },
                                    {
                                        "explanation": "2) move a liquid or substance around with a spoon or stick in order to mix it together 搅；搅拌；搅动",
                                        "example": "Stir the paint to make sure it is smooth."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "immune",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/016b5a560810f73a54c5f44e65604a585de2e6be_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈmjuːn/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (not before noun) specially protected from sth. unpleasant 豁免的；可免于···的",
                                        "example": "The criminal was told that he would be immune from prosecution (起诉) if he helped the police."
                                    },
                                    {
                                        "explanation": "2) safe from a disease, because you cannot be infected by it （对···）免疫的，有免疫力的",
                                        "example": "This blood test will show whether or not you're immune to the disease."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "disturbing",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/acf662d4b9da30aab1ed759492064cfb10968915_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈstɜːbɪŋ/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "worrying or upsetting 令人不安的；使人烦恼的",
                                        "example": "There was something about him that she found very disturbing."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "psychological",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c3a6c6db228a9231461fd6cfb87102fc0459f17f_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌsaɪkəˈlɒdʒɪkl/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "relating to the way that your mind works and the way that this affects your behavior 心理的；精神的",
                                        "example": "Robyn's loss of memory is a psychological problem, rather than a physical one."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "clinical",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/347de940e9e758cdf1a30f4f57f70bcf580b1e08_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈklɪnɪkl/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) relating to treating or testing people who are sick 临床的",
                                        "example": "The therapy has helped people with clinical depression."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "self-conscious",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c0d17b66a4965ab04950331f0f85ba6f07650c64_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌselfˈkɒnʃəs/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "worried and embarrassed about what you look like or what other people think of you （因顾虑自己的外表或他人的看法）忸怩的，害羞的，不自然的",
                                        "example": "Bess was self-conscious about being shorter than her two friends."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "social media",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b6b325a6d733139a59e7995d0984b25f26d7cb82_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌsəʊʃl ˈmiːdiə/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[pl.] websites and software programs used for social networking 社交媒体",
                                        "example": "Social media is changing the way people communicate, work, and shop."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "inspiration",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/88f010d301238d99c1e8474039c00d0a6c1ea43a_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɪnspəˈreɪʃn/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a good idea about what you should do, write, say, etc., esp. one which you get suddenly 灵感",
                                        "example": "Dreams are a rich source of inspiration for some writers."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "makeup",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/41dc4de100299ab136cd94ad9a04730d32589845_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmeɪkˌʌp/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the application of cosmetics 化妆",
                                        "example": "I got my wedding makeup done in this beauty studio."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "destructive",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/620994252c01f02e87dcf66e49d4269ac5a735f5_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈstrʌktɪv/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "causing damage to people or things 毁灭性的；造成破坏的",
                                        "example": "Lack of trust is very destructive in a relationship."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "envious",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1f097dbf425f0cf3cec4da254c346d4002e73f92_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈenviəs/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "wanting sth. that sb. else has 羡慕的；忌妒的",
                                        "example": "I'm so envious of you getting an extra day's holiday."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "psychotherapist",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5f978d2b38aab124d2e4c5a66332202819846b2a_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌsaɪkəʊˈθerəpɪst/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb. who is trained to treat people with a mental illness by talking to them instead of giving them drugs 精神治疗医师"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "resent",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3f78d6cc6791474b9f030ed86b9adee560cb95d6_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈzent/\nvt.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "feel angry or upset about a situation or about sth. that sb. has done, esp. because you think that it is not fair （因受委屈而）对···感到愤恨",
                                        "example": "I resented having to work such long hours."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "resentful",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0f798fc98f5b1dbefe8401398e0c9e4589fe1cf5_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈzentfl/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "feeling angry and upset about sth. that you think is unfair （对不公平的事）愤恨的，不满的，憎恶的",
                                        "example": "They were bitterly resentful of the fact that they had to work such long hours."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "well-being",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8660e3e5dfcea94885ca479e3e273a6618043cd0_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌwel ˈbiːɪŋ/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] a feeling of being comfortable, healthy, and happy 舒适；健康；幸福",
                                        "example": "The warm sunny weather always gives me a sense of well-being."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "urge",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f585510387718c0527d39bd15453e9d5e5d8b34e_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɜːdʒ/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【n.】[C] a strong wish or need 强烈的欲望；迫切的要求；冲动",
                                        "example": "He could no longer resist the urge to go and see Amanda."
                                    },
                                    {
                                        "explanation": "【vt.】strongly suggest that sb. do sth. 竭力主张；强烈要求；敦促",
                                        "example": "They urged Parliament to approve plans for their reform program."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "vulnerable",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1d054f00fbb5eaff99c74db64a98ed2b43f21260_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈvʌln(ə)rəbl/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "able to be easily harmed or hurt 脆弱的；易受伤的",
                                        "example": "Their constant arguments left her feeling increasingly vulnerable and insecure."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "self-esteem",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0d215ed8ded43125e2eac91c61d28fd2834be8d9_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌself ɪsˈtiːm/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the feeling of being satisfied with your own abilities, and that you deserve to be liked or respected 自尊（心）",
                                        "example": "e.g. Educated people are found to have higher self-esteem."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "deprivation",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9af885218af66a7251a65c51190d237d61efd620_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌdeprɪˈveɪʃn/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] the lack of sth. that you need in order to be healthy, comfortable, or happy 缺少；匮乏",
                                        "example": "Sleep deprivation can result in mental disorders."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "tolerance",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1e1ad4c27ec15e8eaede2575def0f83f4894ae2e_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtɒlərəns/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] willingness to allow people to do, say, or believe what they want without criticizing or punishing them 忍受；容忍；宽容",
                                        "example": "He shows little tolerance for people with different views."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "intolerance",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/558fac0233924477dc3fd159f81e6b046a371618_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈtɒlərəns/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] unwillingness to accept ways of thinking and behaving that are different from your own 偏狭；偏执；不容异己",
                                        "example": "The party was accused of stirring up a climate of fear and intolerance."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "worthy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1595f9f26cc849575cb76367dd7cb2410ad03858_96k.mp3#duration=1.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈwɜːði/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "deserving respect, attention, or admiration 值得尊敬的；值得注意的；值得敬仰的",
                                        "example": "The money we raise will be going to a very worthy cause."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "differentiate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e6ca1d569b325ff16999148114c57f2f2f969a62_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌdɪfəˈrenʃiˌeɪt/\nv.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "recognize or express the difference between things or people 辨别；区别",
                                        "example": "It's important to differentiate between fact and opinion."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unhealthy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fb4834d712babb658992e58616f9d7f0d70c459e_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ʌnˈhelθi/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) not normal or natural and likely to be harmful 反常的；病态的",
                                        "example": "Frank has developed what I would term an unhealthy relationship with these people."
                                    },
                                    {
                                        "explanation": "2) likely to make you ill 对健康有害的；会致病的",
                                        "example": "He worked in the unhealthy environment of a coal mine."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "hunger",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2d370cd0beddef88d6563f2c5f79904ee0856fe5_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈhʌŋgə/\nn. [U]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) the feeling that you need to eat 饥饿感",
                                        "example": "I can't believe that that enormous meal wasn't enough to satisfy your hunger."
                                    },
                                    {
                                        "explanation": "2) lack of food, esp. for a long period of time, that can cause illness or death （尤指长期的）饥饿，饥荒",
                                        "example": "Is it possible to end poverty and hunger in a decade?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "coincide",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/572678ebde0e9718c4f74d4d18fbc75f91222107_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌkəʊɪnˈsaɪd/\nvi.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ with) happen at the same time as sth. else, esp. by chance 同时发生（尤指巧合）",
                                        "example": "I timed my holiday to coincide with the children's school holiday."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "insecurity",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e418d39996a3ac61c1efa7113dc7d81a8ce06a3c_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɪnsɪˈkjʊərəti/\nn.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] the state of not feeling at all confident about yourself, your abilities, or your relationships with people 不安全；没有自信；没有把握",
                                        "example": "She had developed an outgoing personality to mask her deep insecurities."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "freelance",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8e4a83c65eafa5e6cd93242c12823c852d81be15_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfriːlɑːns/\na.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "working independently for different companies rather than being employed by one particular company 从事自由职业的",
                                        "example": "He has been a freelance journalist for the BBC for a decade."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "neurosurgery",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e14dd4c44cd65f31b60a3b10387837ebc5cd25de_96k.mp3#duration=2.0&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌnjʊərəʊˈsɜːdʒəri/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] 神经外科（学）",
                                        "example": "Now I am chief of pediatric neurosurgery at John Hopkins Children's Center in Baltimore."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "shocking",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c6a71bc20b698b026cd85917068e876363ef4ba0_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʃɒkɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "very surprising, upsetting, and difficult to believe 惊人的；骇人的；令人难以置信的",
                                        "example": "It is shocking that they involved children in the crime."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "stimulate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5150760a6ac68fafc93dfcc7d2db83f4616be8eb_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈstɪmjʊˌleɪt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "encourage or help an activity to begin or develop further 激励；促使；促进",
                                        "example": "The government should do more to stimulate investment in the rural areas of the state."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "instruct",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e61880fcd926134d45edebd1f27b791fe7b02604_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈstrʌkt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "officially tell sb. what to do 命令；指示",
                                        "example": "He instructed his men to collect information about troop movements."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unrelated",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f1d8c9c4d9fe39b17ebb667415d5cdf54ac21eed_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌʌnrɪˈleɪtɪd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "two things that are unrelated are not connected to each other in any way 无关的；不相关的",
                                        "example": "The police think that the two incidents are unrelated."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "robust",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/92a17b318c4200f3b07e67eff5c5a745eacb71a3_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rəʊˈbʌst/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "having or showing good health and strength 强健的；健壮的",
                                        "example": "He looks robust and healthy."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "contagious",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/431f89ddace7b0fb0b3cce920c69d6c4b2cdd1a5_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈteɪdʒəs/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) if a feeling, attitude, or action is contagious, other people are quickly affected by it and begin to have it or do it （感觉、态度、行动）富于感染力的，会蔓延的",
                                        "example": "Daffy has a contagious enthusiasm for life and poetry."
                                    },
                                    {
                                        "explanation": "2) a disease that is contagious can be passed from person to person by touch （疾病）接触传染的",
                                        "example": "Mumps (腮腺炎) can be a contagious disease."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "laughter",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/467536ea9d78fe32cd401a8c48962362fdb4c340_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlɑːftə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] when people laugh, or the sound of people laughing 笑；笑声",
                                        "example": "He delivered the line perfectly, and everybody roared with laughter."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "induce",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/296760d2b317362f9415a07ef8851aa03a5d6862_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈdjuːs/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (fml.) cause sth., esp. a mental or physical change 引起，促使，导致（尤指精神或身体的变化）",
                                        "example": "Taking a brisk walk can often induce a feeling of well-being."
                                    },
                                    {
                                        "explanation": "2) (fml.) persuade sb. to do sth., esp. sth. that does not seem wise 劝诱，诱导（尤指做似乎不明智的事）",
                                        "example": "Nothing would induce me to take that job."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "duration",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6bd13b76653a47e94a11a38496945a60033b1cd9_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/djʊˈreɪʃn/【n.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the length of time that sth. continues 持续时间",
                                        "example": "For the duration of the strike our shop will remain closed."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "intensity",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0a552d11d84949e22a69b0fc77a1ba20f04d2a21_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈtensɪti/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the quality of being felt very strongly or having a strong effect 强烈；剧烈",
                                        "example": "The storm started again with even greater intensity."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sensation",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/95c3838899cba595c87efb59176d0c8f289d5e46_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/senˈseɪʃn/【n. [C]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) a feeling or an impression caused by a particular experience 感觉；感受",
                                        "example": "I can remember the first time I went sailing — it was a wonderful sensation."
                                    },
                                    {
                                        "explanation": "2) a feeling that you get from one of your five senses, esp. the sense of touch （感官的）感觉；（尤指）触觉",
                                        "example": "Massage (按摩) produces wonderful sensations."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "electric",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/366aaef7c16fb666183eec276a5697a539130f3a_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈlektrɪk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "needing electricity to work, produced by electricity, or used for carrying electricity 用电的；电动的；带电的",
                                        "example": "The electric guitar, along with rock-and-roll, rose to popularity around the world."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "associate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/18fcccdf6e7c3cd9ae97a002e6425a1ac167b983_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈsəʊsiˌeɪt/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "vt. \n(~ sb. / sth. with sth.) make a connection in your mind between one person or thing and another 联想；联系",
                                        "example": "Most people associate this brand with good quality."
                                    },
                                    {
                                        "explanation": "n.\n[C] sb. with whom you work or do business with 同事；（生意）伙伴",
                                        "example": "They have been business associates for decades. "
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "implication",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5f66fb5dbfa6b1884c656b9dea4e0ac305aeb4d7_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɪmplɪˈkeɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [C, U] sth. that is not directly said or shown, but that is suggested or understood 含意；暗指；暗示",
                                        "example": "I resent the implication that my work is not thorough."
                                    },
                                    {
                                        "explanation": "2) [C, usu. pl.] a possible future effect or result of an action, event, decision, etc. （行动、事件、决定等的）可能的影响（后果）",
                                        "example": "The new report has far-reaching implications for the future of broadcasting."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "astonish",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9e152283f0c56e2ddb298f5ba66c78f859f72e57_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈstɒnɪʃ/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "surprise sb. very much 使大为吃惊；使惊愕",
                                        "example": "What astonished me most was her lack of common sense."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "astonishing",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/eece881f6f7c62ae3903636052cd641010c45323_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈstɒnɪʃɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "so surprising that it is difficult to believe 令人惊讶的",
                                        "example": "It's astonishing how much the place has changed."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "neuron",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/55354804a3f8896d6b55d7daaaa7143ba8a18b12_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈnjʊərɒn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (also 'neurone') 神经元；神经细胞"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "neurotransmitter",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/aa8144024c11fb88cc6c859691ba24b20b03f2dc_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈnjʊərəʊtrænzˈmɪtə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 神经传递素"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "electrical",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ca011d43ad88012430bb1cb94575d8c97b20125b_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈlektrɪkl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "connected with electricity; using or producing electricity 电的；用电的；发电的",
                                        "example": "Since the Great Depression, every new electrical appliance has come with a promise that it would transform the home."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "neurophysiology",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3440288b6338a0156cc66f50e3be5869ba9cb2cf_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈnjʊərəʊˌfɪziˈɒlədʒi/【n.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] 神经生理学"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "musical",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0aee997f655712be2b2dc3b6d7482dc887269578_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmjuːzɪkl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) relating to music or consisting of music 音乐的；配乐的",
                                        "example": "She has no formal musical qualifications."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "favorable",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/789fc8fa38e7214708cdd2f85dc85d10dbb657f0_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfeɪv(ə)rəbl/【a. (BrE favourable)",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) suitable and likely to make sth. happen or succeed 有利的",
                                        "example": "The disease spreads quickly under favorable conditions."
                                    },
                                    {
                                        "explanation": "2) a favorable report, opinion, or reaction shows that you think sb. / sth. is good or that you agree with them 赞许的；称赞的；肯定的",
                                        "example": "We have had a favorable response to the plan so far."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "reinforce",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a85419dd5118e4f7ae1f1800eaa9457f6df2e424_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌriːɪnˈfɔːs/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "give support to an opinion, idea, feeling, etc. and make it stronger and more likely to continue 加强，强化（观点、思想、感觉等）",
                                        "example": "The latest figures reinforce the view that economic growth is slowing down."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "rage",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/17cb53dddb68e980ab9b2341a501671f1cc1158b_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/reɪdʒ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] a strong feeling of uncontrollable anger 盛怒；狂怒",
                                        "example": "He would sometimes fly into a rage for no reason at all."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "monster",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/bae4a659ddb04cccb1c90b73ef49220446087d7c_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmɒnstə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] an imaginary or ancient creature that is large, ugly, and frightening 妖怪；怪兽；怪物",
                                        "example": "A terrifying monster attacked the helpless villagers."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "cable",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b9253733f4697585e3b54879ddd4830547384d9b_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkeɪbl/【n.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 电缆"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "handy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a6e5124c158ba520035ac348a3d0745964546a2f_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈhændi/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (infml.) near and easy to reach 手边的；附近的",
                                        "example": "Keep your pills handy just in case you feel seasick."
                                    },
                                    {
                                        "explanation": "2) useful 有用的",
                                        "example": "It's very handy having a light above your desk."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "correlate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cb4ff7a858a8ba9cab009bcbcba98ee0e4e42537_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkɒrəˌleɪt/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ to / with) if two or more facts, ideas, etc. correlate or if you correlate them, they are closely connected to each other or one causes the other （使）相互关联",
                                        "example": "Stress levels correlate strongly with heart disease."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "lifespan",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/34fed83089cda0f7791955e95e68d956f99e1687_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlaɪfˌspæn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] the length of time that a person or animal lives or is expected to live （人或动物的）寿命，预期生命期限",
                                        "example": "Worms have a lifespan of a few months."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unfortunately",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a4975a30dd3d3022050bd3f96c766b993f41487a_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ʌnˈfɔːtʃ(ə)nətli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used when you are mentioning a fact that you wish was not true 不幸地；令人遗憾地",
                                        "example": "Unfortunately, you were out when we called."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "blank",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3a7a0cace30677cb524aa19685f73c6273dc5400_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/blæŋk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) showing no emotion, understanding, or interest 无表情的；木然的",
                                        "example": "Zoe looked at me with a blank expression."
                                    },
                                    {
                                        "explanation": "2) without any writing, print, or recorded sound 无字迹的；空白的",
                                        "example": "Sign your name in the blank space at the bottom of the form."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "indoors",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2407ae4f3a9faee17f41092f8f7959b5adf95ea2_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈdɔːz/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "into or inside a building 往室内；在室内",
                                        "example": "Mother was advised to stay indoors for a week after her cough seemed better."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "captive",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/d9cfb786d5db4c853be121a39aefb60433e58a95_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkæptɪv/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "a.\nkept in prison or in a place that you are not allowed to leave 被关押的；遭监禁的",
                                        "example": "She was kidnapped and held captive for over a week."
                                    },
                                    {
                                        "explanation": "n.\n[C] sb. who is kept as a prisoner 俘虏",
                                        "example": "They freed their captives before surrendering."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "scenario",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/801ed438b34660b895700d544fc14f0651404bee_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/səˈnɑːriəʊ/【n.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a situation that could possibly happen 可能发生的事；可能出现的情况",
                                        "example": "Imagine a scenario where only 20 percent of people have a job."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "captivity",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/67733fc5855015948608e916defedbb0a2544245_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kæpˈtɪvəti/【n.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] when a person or animal is kept in a prison, cage, etc. and not allowed to go where they want 拘禁；囚禁；关押",
                                        "example": "Animals bred in captivity would probably not survive if they were released into the wild."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "autopilot",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7c55f03b61bb03c22588f065c82614d0ab386a7a_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈɔːtəʊˌpaɪlət/【n.",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] (also 'automatic pilot') a machine that flies a plane by itself without the need for a pilot （飞机上的）自动驾驶仪"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Phrases and expressions",
                "children": [
                    {
                        "word": "you name it",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/bdc4adeb6a6a3c12a005821a2e8ab9ba4f5f8f99_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(spoken) used after a list of things to mean that there are many more you could mention 凡是你说得出的（应有尽有）",
                                        "example": "Vodka, whisky, beer — you name it, I've got it."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "miss out",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/67ba32a4e30a3e26f0487c62b38b9c6ea1146123_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "not have the chance to do sth. that you enjoy or that would be good for you 错失机会",
                                        "example": "Well, I'm glad you could make it; I didn't want you to miss out."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "in relation to",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c2e3ba35bb7c0e9e6a385a46c615bbacd828f2e8_96k.mp3#duration=2.0&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "concerning 关于；涉及",
                                        "example": "One of the biggest things that should happen in relation to the Internet is that kids and adults, too, should be taught to manage it."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "measure up",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/771fc499cedd00982c8c3e3b185a2426baee703a_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "be good enough to do a particular job or to reach a particular standard 合格；达到某个标准",
                                        "example": "How will the Secretary General measure up to his new responsibilities?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "when it comes to (doing) sth.",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cb15f767ad2b90823eba887b4f3b4a1bb38a48da_96k.mp3#duration=5.7&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(infml.) when the subject being discussed is a particular thing 谈到（做）某事时",
                                        "example": "He's a bit of an expert when it comes to computers."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "every now and then / again",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/75b5a43a7eb972a959be666afbae3e384d1e8605_96k.mp3#duration=4.8&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(also 'every so often') sometimes, but not often or regularly 偶尔；有时",
                                        "example": "He cleans out his desk drawers every now and then."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "work on",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5d24ce34b620e24c52f992bf7fc9e78ef1a62912_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "try very hard to improve or achieve sth. 努力提高；努力实现",
                                        "example": "We need to work on ensuring that the children feel safe and confident."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sink in",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a61bf1b1af8879a2cca57982ace97a66d9e9e93e_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if information, facts, etc. sink in, you gradually understand them or realize their full meaning （信息、事实等逐渐）被充分理解",
                                        "example": "He paused a moment for his words to sink in."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "for that matter",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/39f2c5e7edea3b725a83721ca2248bd7abbbcff3_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used to say that what you are saying about one thing is also true about sth. else 对···同样如此",
                                        "example": "Ben never touched beer, or any kind of alcohol for that matter."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "(just) in case",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0614bdb604e1f545ca0798d7a9113c1ca83cab9f_96k.mp3#duration=3.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "as a way of being safe from sth. that might happen or might be true 以防万一",
                                        "example": "Take an umbrella, in case it rains."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "on average",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8f5f55a25e62087fdf12e6acd8b7dd83f5c3b36f_96k.mp3#duration=1.8&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "based on a calculation about how many times sth. usually happens, how much money sb. usually gets, how often people usually do sth., etc. 平均来看",
                                        "example": "My income's rather variable, but I earn £73 a day on average."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "up to sth.",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7c30b50cd51a3e7e0dbc9a8e5bf3571e255172af_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(spoken) doing sth. secret or sth. that you should not be doing 正在做（秘密或不该做的事）",
                                        "example": "The children are very quiet. I wonder what they're up to."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "the other way around / round",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c526ad7e55024edfc80238b2b2cc747c48462643_96k.mp3#duration=5.0&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "the opposite of what you have just mentioned 正相反；倒过来",
                                        "example": "Now the reality was just the other way round."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Proper names",
                "children": [
                    {
                        "word": "Facebook",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f465789313d58069a6d4111d008f41e8f43db3bc_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfeɪsbʊk/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "脸书（美国社交网站）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Aristotle",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b8b7e21c36903e0b4363d212167b1193feff3a7e_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈærɪstɒtl/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "亚里士多德（古希腊哲学家、科学家）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Rachel Andrew",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b063da684164a157d443e95a107eec40c94d1665_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌreɪtʃəl ˈændruː/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "雷切尔 · 安德鲁（人名）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Patricia Polledri",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a9cddd759638282e13d18de720bd22adc0f07838_96k.mp3#duration=2.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/pəˌtrɪʃə ˈpɒlədrɪ/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "帕特里夏 · 波莱德里（人名）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Itzhak Fried",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cef23aa9d9133f2c7bf13d40f3e706efd732b4f3_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪtsˌɑːk ˈfriːd/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "伊扎克 · 弗里德（人名）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "UCLA (University of California, Los Angeles)",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/09412b4c9cad0f2d68122a02d764b5b9b948a82b_96k.mp3#duration=2.1&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "加州大学洛杉矶分校"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Frankenstein",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c768d774d8de999531a353aee5a49de01af981f8_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfræŋkənˌstaɪn/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "弗兰肯斯坦（小说人物名）"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]

book1[7] = [
            {
                "name": "New words",
                "children": [
                    {
                        "word": "undeniable",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/46376caddb24d2f3dd7f9ef3d2d760e9cde0bf31_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌʌndɪˈnaɪəbl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "definitely true or certain 不可否认的；无可争辩的",
                                        "example": "The link between poverty and bad health is undeniable."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "mundane",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1c8be1b5a2544bf15c61bbc81db2b2e50eaeac5e_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌmʌnˈdeɪn/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "ordinary and not interesting or exciting 平凡的；平淡的；乏味的",
                                        "example": "The mundane task of setting the table can be fun on holidays."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "bacon",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fa25906c916f9fa41ec411e838605edd71c806eb_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈbeɪkən/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] 咸猪肉；熏猪肉"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "rapt",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/65f412ac5a888a36fe123045ff8e7b6e9be7ffd5_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ræpt/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(written) so interested in sth. that you do not notice anything else 全神贯注的；专心致志的",
                                        "example": "She listened to the speaker with rapt attention."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "marvel",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/eef851b26fb38d6d87a200d552a255d6f13c9ae3_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmɑːvl/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "feel or express great surprise or admiration at sth., esp. sb.'s behavior （尤指对他人的行为）感到惊讶；钦佩；赞美",
                                        "example": "I marvel at my mother's ability to remain calm in crisis."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "app",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8cdeec3948c7c684bda4ef237b86c6c82e560a36_96k.mp3#duration=0.9&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/æp/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 应用程序；应用软件"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "expose",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/963a45a3b3cc8222ea9d87b55eb8f1c9dad777dc_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪkˈspəʊz/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) put sb. in a situation where they are not protected from sth. dangerous or unpleasant 使暴露（于险境）；使置身（于危险）当中",
                                        "example": "The report revealed that workers had been exposed to high levels of radiation."
                                    },
                                    {
                                        "explanation": "2) show sth. that is usu. covered or hidden 显露；露出（通常掩盖或隐藏的东西）",
                                        "example": "He lifted his T-shirt to expose a scar across his chest."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "exposed",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b9679b0c63d042fe3d71afea6ea3149029318404_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪkˈspəʊzd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) not protected from attack 无保护的；易受攻击的",
                                        "example": "These developments leave the company in an exposed position."
                                    },
                                    {
                                        "explanation": "2) not protected from the weather 无遮蔽的；不挡风雨的",
                                        "example": "This side of the garden is exposed to wind."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "nerve",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/dca57aea2b63b4dec2353e24036677871a3fa12f_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/nɜːv/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [C] any of the long threads that carry messages between the brain and parts of the body, enabling you to move, feel pain, etc. 神经",
                                        "example": "She was diagnosed with a rare condition which affected the nerves in her back."
                                    },
                                    {
                                        "explanation": "2) (~s) [pl.] feelings of worry or anxiety 神经紧张；焦虑不安",
                                        "example": "Sean drank a large glass of brandy to calm his nerves."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "humanity",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/868f5cc1d032f0f4ca6c8f1dba11812aed6b2b17_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/hjuːˈmænəti/【n.】 [U]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) the state of being human rather than an animal or machine 人性",
                                        "example": "When we're in touch with our common humanity, we remember that feelings of disappointment are universal."
                                    },
                                    {
                                        "explanation": "2) people in general 人；人类（总称）",
                                        "example": "We want a clean environment for all humanity."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "interaction",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/21338c9d6c3320af166ada2994418a5364e361f1_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɪntərˈækʃn/【n.】 [C, U]",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (~ with / between / among) the activity of talking to other people, working together with them, etc. 交流",
                                        "example": "The researchers watch through a two-way mirror the interaction between mother and child in a small room."
                                    },
                                    {
                                        "explanation": "2) a process by which two or more things affect each other 相互影响；相互作用",
                                        "example": "Price is determined through the interaction of demand and supply."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "inhuman",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1476f4b1df914f04d43ad3559e7b58acd663a0cb_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈhjuːmən/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) lacking any human qualities in a way that seems strange or frightening （怪异、恐怖而）异于人类的",
                                        "example": "I quit this inhuman job. I don't want to work for a machine."
                                    },
                                    {
                                        "explanation": "2) very cruel or without any normal feelings of pity 残暴的；无同情心的",
                                        "example": "The prisoners had suffered inhuman treatment."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "confuse",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/39c52b1bad4edbaf67876c67663cfc1a912877ea_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈfjuːz/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. feel that they cannot think clearly or do not understand 使困惑；把（某人）弄糊涂",
                                        "example": "I understand the text but the diagrams are confusing me."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "confusing",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c3576a855137242669bb623356764e4dc1f4a75c_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈfjuːzɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "unclear and difficult to understand 令人困惑的；模糊不清的；难懂的",
                                        "example": "The road signs were very confusing and we ended up getting lost."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "seemingly",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ee9947084a40950d220a593234f0255ac9fed224_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈsiːmɪŋli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "in a way that appears to have a particular quality when this may or may not be true 看上去；表面上；外观上",
                                        "example": "The new minister was faced with a seemingly impossible task."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "conflicting",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/66d70866f6e27f0a456d01027c772c73641932d6_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌkənˈflɪktɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "conflicting ideas, beliefs, opinions, etc. cannot exist together or both be true （想法、信仰、观点等）冲突的，矛盾的",
                                        "example": "It can be difficult to balance the conflicting demands for our time."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "lament",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fc16531cc79a7ab79ae2d9f0802b45112e67cd0c_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ləˈment/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) express annoyance or disappointment about sth. that you think is unsatisfactory or unfair 抱怨",
                                        "example": "He lamented that people had expected too much of him."
                                    },
                                    {
                                        "explanation": "2) express feelings of great sadness about sth. （为···）悲痛，痛惜",
                                        "example": "The nation lamented the death of its great leader."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "ubiquitous",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/752ac1ffc999d9228ffeb83f0476e7696ae8e6d3_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/juːˈbɪkwɪtəs/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(fml.) seeming to be everywhere — sometimes used humorously 似乎无处不在的（有时为幽默手法）",
                                        "example": "He is as recognizable and as ubiquitous as the celebrities he photographs."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "advanced",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/890542066eb10d9c3e12058790d4d3df2abd5482_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ədˈvɑːnst/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "very modern 先进的",
                                        "example": "Modern armies consist of fewer soldiers and more advanced weapon systems."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "capture",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/73288ee952ceb30b01e1e536ae6ea1872b169096_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkæptʃə/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (~ sb's imagination / attention, etc.) make sb. feel very interested in sth. 引起某人想象；吸引某人注意等",
                                        "example": "His stories of foreign adventure captured my imagination."
                                    },
                                    {
                                        "explanation": "2) catch a person and keep them as a prisoner 俘虏；逮捕",
                                        "example": "Government troops have succeeded in capturing the rebel leader."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "category",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/de71d1a82f66e746c4f27766e8f87b9d94aeb439_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkætəg(ə)ri/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a group of people or things that are all of the same type 类别；种类；范畴",
                                        "example": "Seats are available in ten price categories."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "categorize",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c5c24fa8992143bdec68d2195ec11b32237c343e_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈkætɪgəˌraɪz/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(BrE categorise) put people or things into groups according to the type of person or thing they are 对···进行分类；把···归类",
                                        "example": "The population is categorized according to age, sex, and social group."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "viewpoint",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/33dec8ece188859c8c3e7baffdd5429fd8468fd6_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈvjuːˌpɔɪnt/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] a particular way of thinking about a problem or subject 观点；看法；见解",
                                        "example": "From a practical viewpoint, I'd advise you not to go."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "equip",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0b10eacc17ba4857b3a635d1b2d7cc3b342f278a_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈkwɪp/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) give sb. the information and skills that they need to do sth. 使有能力；使能够胜任",
                                        "example": "We equip students with the skills they will need once they leave college."
                                    },
                                    {
                                        "explanation": "2) provide a person or place with the things that are needed for a particular kind of activity or work 装备；配备",
                                        "example": "They spent a lot of money equipping the school with new computers."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "observation",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3f63424290777ebd6a8a8bbbad1dac5ba8bf25ab_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɒbzəˈveɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [C] sth. that you notice when watching sb. / sth. 观察结果",
                                        "example": "Some interesting observations emerged from this research."
                                    },
                                    {
                                        "explanation": "2) [C, U] the process of watching sb. / sth. carefully for a period of time 观察；注意；监视",
                                        "example": "Most information was collected by direct observation of the animals' behavior."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "dynamic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/24be8962770f127411c477c678bce2d9491bc0f8_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/daɪˈnæmɪk/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "【n.】(~s) [pl.] the way in which things or people behave, react, and affect each other 动态；（事物或人）相互作用的方式",
                                        "example": "He did research on group dynamics and leadership styles."
                                    },
                                    {
                                        "explanation": "【a.】1) continuously moving or changing 不断移动的；不断变化的；动态的",
                                        "example": "These countries are characterized by highly dynamic economies."
                                    },
                                    {
                                        "explanation": "2) full of energy and new ideas, and determined to succeed 精力充沛的；有创新思想的；志在成功的",
                                        "example": "We're looking for someone positive and dynamic."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "revealing",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c5b7ef6c5ceb9fc8e45058e78610210264e12b9e_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈviːlɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "a remark or event that is revealing shows you sth. interesting or surprising about a situation or sb.'s character 揭露真相的；揭示内情的",
                                        "example": "The document provided a revealing insight into the way government works."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "occasional",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b887ca27936ee160735ea98e2234bb38caa52cb5_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈkeɪʒn(ə)l/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) happening sometimes but not often or regularly 偶尔的；不经常的",
                                        "example": "He spent five years in Paris, with occasional visits to Italy."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "intertwine",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/3c2c86cd37d26764e5b0f763637d97fc3f2cde5f_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌɪntəˈtwaɪn/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) if two things intertwine, or if they are intertwined, they are twisted together （使）缠绕；（使）交织在一起",
                                        "example": "He told us a story in which the present and the past intertwined."
                                    },
                                    {
                                        "explanation": "2) if two situations, ideas, etc. are intertwined, they are closely related to each other （使）（局势、观点等）紧密相关",
                                        "example": "Her fate intertwined with his."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "continuously",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/546f7eeb258e93da151ccd707483e3dc512630ae_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈtɪnjʊəsli/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "without a pause or interruption 持续地；不间断地",
                                        "example": "He has lived and worked in France almost continuously since 1990."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "lens",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/cf3b0bfc0cb90956881a96316b9cf5de0385954e_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/lenz/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C]（照相机的）镜头"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "re-frame",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/80b5d98bbee10ba3fc1ae150e49325b8e3160b5b_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈfreɪm/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "frame or express (words, or a concept or plan) differently 全新地拟定（或表达）（话语、概念或计划）",
                                        "example": "She is trying to re-frame the debate about the care of children in need."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "cellphone",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/875d0ce6362a66c3064de5267329f489b993e934_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈselˌfəʊn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] (BrE mobile phone)  移动电话；手机"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "rebellious",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5bf72154751dba76eb5827c034a54d83e92234ce_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/rɪˈbeljəs/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "deliberately not obeying people in authority or rules of behavior 叛逆的；反叛的；反抗的",
                                        "example": "Her teachers consider her a rebellious, trouble-making girl."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "old-fashioned",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/202ad02cc25372eb6d1ffa7fa0c5ef97ed44a910_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌəʊld ˈfæʃnd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "not considered to be modern or fashionable anymore 旧式的；老式的；过时的",
                                        "example": "His idea is regarded as rather old-fashioned."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "flip phone",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/ee537cdbf7130d7c7b6501751d5ce9347c81bed0_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈflɪp ˌfəʊn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] 翻盖手机"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "insane",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/eb532b613aafa5616a8caa76d9c392c7203dff6e_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈseɪn/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(infml.) completely stupid or crazy, often in a way that is dangerous 愚蠢的；疯狂的",
                                        "example": "For some insane reason he decided to do the whole journey in one day."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "monthly",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0dcd130dfe96804c812659e0a08579142951714d_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmʌnθli/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(only before noun) used to talk about the total amount of sth. that is received, paid, measured, or calculated in a month 按月结算的；每月的",
                                        "example": "Summers are hot here, with monthly average temperature above 30 °C."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "possibility",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/61f1fb5f61f4c80e42ba2dc4ac11c76e942fa61f_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌpɒsəˈbɪləti/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] if there is a possibility that sth. is true or that sth. will happen, it might be true or it might happen 可能；可能性",
                                        "example": "There is always a possibility that he might go back to Seattle."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "upgrade",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/23460968b20a42d90b3c2f248d537c1c8d05eeca_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈʌpˌgreɪd/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] the act of making a computer, machine, or piece of software better and able to do more things （计算器、机器、软件的）升级",
                                        "example": "The upgrade to the latest version costs $395."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "roaming",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/fe515ea985343fce6878ceafd7b351d1f7572a6a_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈrəʊmɪŋ/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the process that a mobile phone uses when it is in a different country or area from usual, and has to connect to a different network （手机）漫游"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "transmit",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e2a5c8219924e9fcc01b6a1e3185cfa717131f02_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/trænzˈmɪt/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "send out electronic signals, messages, etc. using radio, television, or other similar equipment 传输，发送，传送（电子信号、信息等）",
                                        "example": "The system transmits information over digital phone lines."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "emission",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/614d56848e319ca075449cf825a71e0f33b738a9_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈmɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, usu. pl.] a gas or other substance that is sent into the air 排放物；散发物",
                                        "example": "The government has decided to clean up industrial emissions."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "landfill",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/780b962a7c518a4c5752cd98f24b988251dbfaf5_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlændˌfɪl/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) [C] a place where waste is buried under the ground 废弃物填埋场"
                                    },
                                    {
                                        "explanation": "2) [U] the practice of burying waste under the ground, or the waste buried in this way 废弃物的填埋；填埋的废弃物"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "toxic",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/205e88ea63e49ede4ea4f558313755dbd991e4f5_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈtɒksɪk/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "containing poison, or caused by poisonous substances 有毒的；由有毒物质引起的",
                                        "example": "Toxic chemicals have been spilled into the river for the past three months."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "decisive",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4cc4083d7e18eff924f17ddcdbad64dfb3fe59ed_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/dɪˈsaɪsɪv/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "an action, event, etc. that is decisive has a big effect on the way that sth. develops 决定性的；关键性的",
                                        "example": "It is the chief executive's opinion that is ultimately decisive."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "anytime",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c34748cd31210e7a4b5aba2d1e32d85753db8ec4_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈeniˌtaɪm/【ad.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "at a time that is not fixed 任何时候",
                                        "example": "They should arrive anytime between noon and 3 p.m."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "liberate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1cc289deb7da4b6a2c1f995091f07e5c40c5dfaf_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈlɪbəˌreɪt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "free sb. from feelings or conditions that make their life unhappy or difficult 使自由；使摆脱束缚",
                                        "example": "Writing poetry liberated her from the routine of everyday life."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "overwhelming",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2b00c54c48b40f88e0b45020c9b9a16ec2c6552b_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌəʊvəˈwelmɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "having such a great effect on you that you feel confused and do not know how to react 难以抗拒的；令人不知所措的",
                                        "example": "She felt an overwhelming desire to tell someone about what had happened."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "burden",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/acbc2123c98ce7925ccb957413e3c2bb5a240e1b_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈbɜːdn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sth. difficult or worrying that you are responsible for 重担；负担",
                                        "example": "His family responsibilities have started to become a burden."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "temptation",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/142a17f7bf95fe4be3949435805a43bfa0195401_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/tempˈteɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C, U] (~ to do sth.) a strong desire to have or do sth. even though you know you should not 引诱；诱惑",
                                        "example": "Resist the temptation to buy the item until you're certain you need it."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "presence",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b0b5a2107a9d250e8798036892894d7b33b4c846_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈprezns/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] when sb. / sth. is present in a particular place 出席；到场；存在",
                                        "example": "Your presence is requested at the club meeting on Friday."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "witness",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/23e0b1436065b34f9f480ea9ca4f80e28950c608_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈwɪtnəs/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb. who sees a crime, accident or other event and can describe what happened （罪案、事故、事件的）目击者",
                                        "example": "According to witnesses, the thief escaped through the bedroom window."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "intrude",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5a7a4bdfb2228140af385a6d943f6439ca985880_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈtruːd/【vi.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "interrupt sb. or become involved in their private affairs, in an annoying and unwanted way 打扰；干涉",
                                        "example": "Would I be intruding if I came with you?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "intrusive",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/22144468f1b1a8324acd869506f5ba4c988d927c_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪnˈtruːsɪv/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "affecting sb's private life or interrupting them in an unwanted and annoying way 干涉的；打扰的",
                                        "example": "Some residents of the island found the presence of the film crew too intrusive."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "patience",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1fe702087832f1dd2b180e6b15bf64ba749152fe_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈpeɪʃns/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the ability to continue waiting or doing sth. for a long time without becoming angry or anxious （持续等待或长时间做某事的）耐心",
                                        "example": "Teaching children with special needs requires patience and understanding."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "empathy",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9bd5edeca01b55707cc82c9e37b0259f2a79d5dd_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈempəθi/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the ability to understand other people's feelings and problems 同情；同感；共鸣",
                                        "example": "The nurse should try to develop empathy between herself and the patient."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "affection",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/817ae4201e24e1e2c2923663ba98098b0f10b4ae_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əˈfekʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U, sing.] a feeling of liking or love and caring 喜爱；钟爱；慈爱",
                                        "example": "She looked back on those days with affection."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "contemplation",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/76e474aa549afcf73debda350c46262a2624ea6c_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌkɒntemˈpleɪʃn/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] quiet serious thinking about sth. 沉思；冥想；默想",
                                        "example": "The monks spend an hour on contemplation each morning."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "essential",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9dce401ca9e14ae468d77f9d4293231b4b4c817d_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ɪˈsenʃl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(~ for / to) extremely important and necessary 极其重要的；必不可少的",
                                        "example": "It is becoming almost essential for students to learn a second language."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fulfil",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/86f2e001103df022bbdf8a8925d2953ccc67bc85_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/fʊlˈfɪl/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if you fulfil a hope, wish, or aim, you achieve the thing that you hoped for, wished for, etc. 实现（希望、愿望、目标等）",
                                        "example": "Visiting Disneyland has fulfilled my boyhood dream."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fulfilling",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/943ea072b09a400bd166de96f2f7121865085c44_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/fʊlˈfɪlɪŋ/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "making you feel happy and satisfied because you are doing interesting, useful, or important things 令人满意的",
                                        "example": "Each of these courses is academically challenging and personally fulfilling."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "compatible",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/634c6b68f1c618d114823d03609c30b0ea449222_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kəmˈpætəbl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "able to exist or be used together without causing problems 可共存的；可兼用的",
                                        "example": "Are measures to protect the environment compatible with economic growth?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "gratitude",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6ecdb26884023e1ea9aca33137c49a9bcf21662d_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈgrætɪˌtjuːd/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the feeling of being grateful 感激（之情）",
                                        "example": "I would like to express my gratitude to everyone for their hard work."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Greek",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/6e47271d03f8419ae61d96af7cf13a8d034298c8_96k.mp3#duration=1.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/griːk/【a. 】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "relating to Greece, its people, or its language 希腊的；希腊人的；希腊语的"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "anticipate",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/b330d9251c20f929434c65ecc8968e20575a312e_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ænˈtɪsɪˌpeɪt/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "expect that sth. will happen and be ready for it 预期；预料",
                                        "example": "We need someone who can anticipate and respond to changes in the fashion industry."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "meaningful",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/017bc9b90bd52fda3a6487a0bf1e67a228774fdb_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈmiːnɪŋfl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) serious, important, or useful 严肃的；重要的；有用的",
                                        "example": "They want a chance to do meaningful work."
                                    },
                                    {
                                        "explanation": "2) having a meaning that is easy to understand and makes sense 有意义的；浅显易懂的",
                                        "example": "These statistics are not meaningful to anyone but a scientist."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "absorbed",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9141ffdc3a707a54392a4bdcdb110fd6f65c8193_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/əbˈzɔːbd/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "so interested or involved in sth. that you do not notice anything else 极感兴趣的；全神贯注的；专注的",
                                        "example": "Judith was totally absorbed in her book."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "willpower",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2ab31c12befad875fdf4b8294a03364963e8796e_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈwɪlˌpaʊə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[U] the ability to control your mind and body in order to achieve sth. that you want to do 毅力；意志力",
                                        "example": "It took all his willpower to remain calm."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "owner",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/4a4d18f4c89c1de61f707fdb8f28dc9e10ab9430_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈəʊnə/【n.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "[C] sb. who owns sth. 所有人；物主；业主",
                                        "example": "The police have been unable to trace the owner of the vehicle."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "guarantee",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/80ba81bd94efca94fe93e8b4db7bd92ca06899f3_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌgærənˈtiː/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) make it certain that sth. will happen 使必然发生；确保",
                                        "example": "The process of training does not automatically guarantee you a job."
                                    },
                                    {
                                        "explanation": "2) promise to do sth. or promise that sth. will happen 保证",
                                        "example": "I guarantee you will love this film."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "bind",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/9417600f864c32b68c4321ece5f8ad15672fc8a5_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/baɪnd/【vt.】(bound, bound)",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "tie sb. / sth. so that they cannot move or are held together firmly 捆绑；系",
                                        "example": "They bound the package with brightly colored ribbons."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "fasten",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0eda2e522cff00b5922a0df1bc97a2320923519e_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˈfɑːsn/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "close or join together the two parts of sth; become closed or joined together （使两部分）系牢，扎牢，结牢，扣紧",
                                        "example": "I was so fat that my skirt wouldn't fasten."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "unreal",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/180e64adc9d1160958c6849ee72f549e8611c655_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌʌnˈrɪəl/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) (not before noun) an experience, situation, etc. that is unreal seems so strange that you think you must be imagining it 不真实的；虚幻的",
                                        "example": "It seemed unreal to be talking to someone so famous."
                                    },
                                    {
                                        "explanation": "2) not related to real things that happen 脱离现实的；不切实际的",
                                        "example": "Many people have unreal expectations of what marriage will be like."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "disconnect",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/e4ba72be0558cad374753d0fac54801f9c97db85_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌdɪskəˈnekt/【v.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "1) if you disconnect or become disconnected from your feelings, family, society, etc., you no longer feel you belong or have a relationship with them （使）脱离（关系）；（使）不联系",
                                        "example": "Divorced men can too easily become disconnected from their children."
                                    },
                                    {
                                        "explanation": "2) remove the supply of power, gas, water, etc. from a machine or piece of equipment 切断（机器或设备）的电力（煤气、水）等供应",
                                        "example": "You should pay attention to disconnecting the machine from the mains first."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "convince",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/2a9baa10cbb05cd7412a1aaff1ff678d5c5da0b4_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈvɪns/【vt.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "make sb. feel certain that sth. is true 使确信；使信服",
                                        "example": "Her arguments didn't convince everyone, but changes were made."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "convinced",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/f418d25529ac67082f847fd845fc50cac7b0b86f_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/kənˈvɪnst/【a.】",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "(not before noun) feeling certain that sth. is true 确信的；信服的",
                                        "example": "I was convinced that we were doing the right thing."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Phrases and expressions",
                "children": [
                    {
                        "word": "worlds apart",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/939b4f2b92713becd836514e5c4cac979d986fd3_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "completely different in attitudes, opinions, etc. （观点、态度等）有天壤之别",
                                        "example": "On the surface, they look the same. But in reality, they are worlds apart."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "hand down",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/368231ea70f23247e879b1f4220f1188283b4388_96k.mp3#duration=1.4&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "give or leave sth. to people who will live after you 传给（后代）",
                                        "example": "The ring was handed down to her from her grandmother."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "hang on sb.'s every word / words",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/1d4e983c1be5f738027f5e29d4291041cdc5e5ff_96k.mp3#duration=5.2&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "pay close attention to everything sb. is saying 倾听（注意）某人每一个字 / 说的话",
                                        "example": "She was watching him, hanging on his every word. "
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "long to do sth.",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/8e91fa4363118614c2d2c1c653b6e878352c8d58_96k.mp3#duration=1.9&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "want sth. very much, esp. when it seems unlikely to happen soon 渴望；盼望",
                                        "example": "These were the words she had secretly longed to hear."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "touch / hit a (raw) nerve",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c9cc8af9697f2fb112b09351ac50c3988b780db4_96k.mp3#duration=3.8&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "mention sth. that makes sb. upset, angry, or embarrassed, esp. accidentally （尤指无心地）触到敏感话题，触到痛处",
                                        "example": "You touched a raw nerve when you mentioned his first wife."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "sum up",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/abc8deb8c3f27672ad8ae90509b1e09d319bccf5_96k.mp3#duration=1.2&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "show the most typical qualities of sb. / sth., esp. in a few words 简而言之；概括",
                                        "example": "For me, the novel summed up the major problems of human existence."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "break down",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0881380dc94eb84817f561ddaa7f8ec366b0045e_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "separate sth. into smaller parts so that it is easier to do or understand 拆分；把···分成若干部分（以方便做或理解）",
                                        "example": "The question can be broken down into two parts."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "in short",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/c52f63075723963c844106fd8f7fa147b9a4ef0e_96k.mp3#duration=1.3&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used when you want to give the main point of sth. 总而言之；简单地说",
                                        "example": "His novels belong to a great but vanished age. They are, in short, old-fashioned."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "engage with",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/449ccc9abfcf503e182797da924fef34d05662b9_96k.mp3#duration=1.5&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "become involved with and try to understand sb. / sth. 与···建立密切关系；尽力理解",
                                        "example": "Are you so tired that you don't have the energy to engage with your kids?"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "(be) on call",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/0437a32fd4a3bbe1aee9edfb2038621e2cd9820e_96k.mp3#duration=3.1&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "if sb. such as a doctor or engineer is on call, they are ready to go and help whenever they are needed as part of their job （医生、工程师等）待命，随叫随到",
                                        "example": "Don't worry, there is a doctor on call 24 hours a day."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "bear witness (to sth.)",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/a751e636652b1387e782b0f758a614aac161ed81_96k.mp3#duration=4.2&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "show that sth. is true or exists 见证（某事）；（为某事）证明",
                                        "example": "The empty workshops bear witness to the industrial past."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "on the contrary / quite the contrary",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/38ae5ecedf41906524874155eb748480812dbc5a_96k.mp3#duration=4.3&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "used to add to a negative statement, to disagree with a negative statement by sb. else, or to answer no to a question 正相反；恰恰相反",
                                        "example": "It wasn't a good thing; on the contrary it was a huge mistake."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Proper names",
                "children": [
                    {
                        "word": "The New Yorker】",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/7cffe4caebafbc3f2645bb6b507c936ecf7a17fb_96k.mp3#duration=1.6&t=.mp3",
                        "pee": [
                            {
                                "explanations_and_examples": [
                                    {
                                        "explanation": "《纽约客》（美国知识、文艺类综合杂志）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Anaxagoras",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/5d8b2277f6dce63a975a06d83230ba68968a1d3b_96k.mp3#duration=2.1&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌænækˈsægərəs/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "阿那克萨哥拉（古希腊哲学家）"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "word": "Pew survey",
                        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_1+202008/resource/audio/38308e5bda3e2fef015901162e91b8dd71c105a9_96k.mp3#duration=1.7&t=.mp3",
                        "pee": [
                            {
                                "partOfSpeech": "/ˌpjuː ˈsɜːveɪ/",
                                "explanations_and_examples": [
                                    {
                                        "explanation": "皮尤调查（美国 Pew Research Center 开展的民意调查）"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
export default book1;